// hotel/F&B/CashierFBMgmt.js
import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  Box,
  Grid,
  Paper,
  Typography,
  TextField,
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Card,
  CardContent,
  Chip,
  IconButton,
  InputAdornment,
  Avatar,
  Tooltip,
  Divider,
  Alert,
  Snackbar,
  Tabs,
  Tab,
  useMediaQuery,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Badge,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Fade,
  Zoom,
  Grow,
  Skeleton,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  Paper as MuiPaper,
  Slide,
  alpha,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ToggleButton,
  ToggleButtonGroup,
  Stack,
  LinearProgress,
  TableFooter,
  TablePagination,
  Switch,
  FormControlLabel as MuiFormControlLabel
} from '@mui/material';
import {
  Receipt,
  Search,
  Refresh,
  Restaurant,
  TrendingUp,
  CheckCircle,
  Cancel,
  Print,
  AttachMoney,
  Fastfood,
  LocalBar,
  RoomService,
  DeliveryDining,
  TakeoutDining,
  Label,
  Phone,
  TableRestaurant,
  LocalHotel,
  CalendarToday,
  FilterList,
  Visibility,
  Money,
  CreditCard,
  AccountBalance,
  CardGiftcard,
  QrCodeScanner,
  ReceiptLong,
  DateRange,
  Clear,
  DoneAll,
  HourglassEmpty,
  EmojiEmotions,
  Kitchen,
  Schedule,
  ExpandMore,
  Payment,
  History,
  Summarize,
  Download,
  PictureAsPdf,
  WhatsApp,
  Email,
  PrintDisabled,
  VerifiedUser,
  Security,
  PointOfSale,
  BarChart,
  PieChart,
  ShowChart,
  WarningAmber,
  Info,
  CheckCircleOutline,
  CancelOutlined,
  Payment as PaymentIcon,
  LockClock,
  History as HistoryIcon,
  PlayArrow,
  Today,Person,
  Refresh as RefreshIcon
} from '@mui/icons-material';
import { styled, keyframes, alpha as muiAlpha } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../../../../components/sidebars/sidebar_cashier';
import TopNav from '../../../../components/TopNav_hotelStaff';
import ClosePreviousShift from './ClosePreviousShift';
// Animations
const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const pulse = keyframes`
  0% { transform: scale(1); opacity: 0.7; }
  50% { transform: scale(1.05); opacity: 1; }
  100% { transform: scale(1); opacity: 0.7; }
`;

const shimmer = keyframes`
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
`;

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

// Styled Components
const OrderCard = styled(Card)(({ theme, status }) => {
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'pending': return theme.palette.warning.light;
      case 'confirmed': return theme.palette.info.light;
      case 'preparing': return theme.palette.primary.light;
      case 'ready': return theme.palette.success.light;
      case 'served': return theme.palette.success.main;
      case 'completed': return theme.palette.success.dark;
      case 'cancelled': return theme.palette.error.light;
      default: return theme.palette.grey[300];
    }
  };

  return {
    border: `2px solid ${getStatusColor(status)}`,
    borderRadius: '20px',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    overflow: 'hidden',
    animation: `${fadeInUp} 0.5s ease-out`,
    cursor: 'pointer',
    position: 'relative',
    '&:hover': {
      transform: 'translateY(-8px)',
      boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
    },
  };
});

const StatusBadge = styled(Box)(({ theme, status }) => {
  const getColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'pending': return theme.palette.warning.main;
      case 'confirmed': return theme.palette.info.main;
      case 'preparing': return theme.palette.primary.main;
      case 'ready': return theme.palette.success.main;
      case 'served': return theme.palette.success.dark;
      case 'completed': return theme.palette.success.dark;
      case 'cancelled': return theme.palette.error.main;
      default: return theme.palette.grey[500];
    }
  };

  return {
    backgroundColor: getColor(status),
    color: 'white',
    padding: '6px 14px',
    borderRadius: '30px',
    fontSize: '11px',
    fontWeight: 'bold',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  };
});

const StatCard = styled(Card)(({ theme }) => ({
  background: `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${muiAlpha(theme.palette.primary.light, 0.05)} 100%)`,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '24px',
  transition: 'all 0.3s ease',
  position: 'relative',
  overflow: 'hidden',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: theme.shadows[12],
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '4px',
    background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
  },
}));

const PaymentMethodCard = styled(Card)(({ theme, selected }) => ({
  border: selected ? `2px solid ${theme.palette.success.main}` : `1px solid ${theme.palette.divider}`,
  borderRadius: '16px',
  transition: 'all 0.3s ease',
  cursor: 'pointer',
  position: 'relative',
  overflow: 'hidden',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: theme.shadows[8],
  },
  ...(selected && {
    backgroundColor: muiAlpha(theme.palette.success.main, 0.05),
  }),
}));

const CloseDayButton = styled(Button)(({ theme, canclose }) => ({
  background: canclose 
    ? 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)'
    : 'linear-gradient(135deg, #9e9e9e 0%, #757575 100%)',
  color: 'white',
  padding: '10px 24px',
  borderRadius: '40px',
  fontSize: '14px',
  fontWeight: 'bold',
  textTransform: 'none',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: canclose ? 'scale(1.05)' : 'none',
    boxShadow: canclose ? '0 8px 25px rgba(220, 38, 38, 0.3)' : 'none',
    background: canclose 
      ? 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)'
      : 'linear-gradient(135deg, #9e9e9e 0%, #757575 100%)',
  },
  '&:disabled': {
    background: 'linear-gradient(135deg, #9e9e9e 0%, #757575 100%)',
    color: 'rgba(255,255,255,0.7)',
  },
}));

const RefreshButton = styled(IconButton)(({ theme }) => ({
  background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
  color: 'white',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'rotate(180deg)',
    background: 'linear-gradient(135deg, #1e88e5 0%, #1976d2 100%)',
  },
  '& .MuiSvgIcon-root': {
    transition: 'transform 0.5s ease',
  },
}));

// Constants
const PAYMENT_METHODS = [
  { value: 'Cash', label: 'Cash', icon: <Money />, color: '#4CAF50', description: 'Cash payment' },
  { value: 'POS Terminal', label: 'POS Terminal', icon: <CreditCard />, color: '#2196F3', description: 'Card payment via POS' },
  { value: 'Bank Transfer', label: 'Bank Transfer', icon: <AccountBalance />, color: '#9C27B0', description: 'Direct bank transfer' },
  { value: 'Complimentary', label: 'Complimentary', icon: <CardGiftcard />, color: '#FF9800', description: 'Complimentary (No Payment)', isFree: true },
];

const ORDER_TYPES = [
  { value: 'dine_in', label: 'Bar/Skyline', icon: <LocalBar />, color: '#1976D2' },
  { value: 'Lounge', label: 'Lounge/Arena', icon: <LocalBar />, color: '#1976D2' },
  { value: 'room_service', label: 'Room Service', icon: <RoomService />, color: '#2E7D32' },
  { value: 'takeaway', label: 'Takeaway', icon: <TakeoutDining />, color: '#ED6C02' },
  { value: 'delivery', label: 'Delivery', icon: <DeliveryDining />, color: '#0288D1' },
];

// API URL
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const HOTEL_NAME = process.env.REACT_APP_HOTEL_NAME || 'Frankville Hotels';
const TAX_RATE = parseFloat(process.env.REACT_APP_HOTEL_TAX) || 0;
const SERVICE_CHARGE_RATE = parseFloat(process.env.REACT_APP_HOTEL_SERVICE_CHARGE) || 0;

// Helper Functions
const getCurrentStaffId = () => {
  try {
    const storedProfile = JSON.parse(localStorage.getItem('userProfile')) || {};
    return storedProfile.staff_id || storedProfile.id || storedProfile.staffId || null;
  } catch (error) {
    console.error('Error getting staff ID:', error);
    return null;
  }
};

const getCurrentStaffName = () => {
  try {
    const storedProfile = JSON.parse(localStorage.getItem('userProfile')) || {};
    return storedProfile.first_name || storedProfile.name || 'Cashier';
  } catch (error) {
    console.error('Error getting staff name:', error);
    return 'Cashier';
  }
};

const getHotelCode = () => {
  try {
    const storedProfile = JSON.parse(localStorage.getItem('userProfile')) || {};
    return storedProfile.hotelcode || storedProfile.hotel_code || storedProfile.hotelCode || '';
  } catch (error) {
    console.error('Error getting hotel code:', error);
    return '';
  }
};

const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN', minimumFractionDigits: 2 }).format(amount || 0);
};

const formatDate = (dateString) => {
  return new Date(dateString).toLocaleString('en-NG', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Helper to get date string in YYYY-MM-DD format
// Helper to get date string in YYYY-MM-DD format
const getDateOnly = (dateTimeStr) => {
  if (!dateTimeStr) return '';
  // Handle both '2026-04-27 11:35:18' and '2026-04-27T11:35:18' formats
  return dateTimeStr.split(' ')[0].split('T')[0];
};

// API Service
const apiService = {
  getOrders: async (params = {}) => {
    const response = await axios.get(`${API_BASE_URL}/hotel/F&B/orders.php`, {
      params: { hotel_code: getHotelCode(), ...params }
    });
    return response.data;
  },

  getInventoryItems: async () => {
    const response = await axios.get(`${API_BASE_URL}/hotel/F&B/inventory.php`, {
      params: { hotel_code: getHotelCode() }
    });
    return response.data;
  },

  getPayments: async (params = {}) => {
    const response = await axios.get(`${API_BASE_URL}/hotel/F&B/payments.php`, {
      params: { hotel_code: getHotelCode(), ...params }
    });
    return response.data;
  },

  recordPayment: async (orderId, paymentData) => {
    const response = await axios.post(`${API_BASE_URL}/hotel/F&B/payments.php`, {
      order_id: orderId,
      hotel_code: getHotelCode(),
      ...paymentData,
      created_by: getCurrentStaffId()
    });
    return response.data;
  },
  
  getCurrentShift: async () => {
    const response = await axios.get(`${API_BASE_URL}/hotel/F&B/shifts.php`, {
      params: {
        hotel_code: getHotelCode(),
        staff_id: getCurrentStaffId(),
        include_history: 'true'
      }
    });
    return response.data;
  },
  
  closeDay: async (closureReason) => {
    const response = await axios.post(`${API_BASE_URL}/hotel/F&B/shifts.php?action=close_day`, {
      hotel_code: getHotelCode(),
      closed_by_staff_id: getCurrentStaffId(),
      closure_reason: closureReason || 'End of day closure'
    });
    return response.data;
  },
  
  startNewDay: async () => {
    const response = await axios.post(`${API_BASE_URL}/hotel/F&B/shifts.php?action=start_new_day`, {
      hotel_code: getHotelCode(),
      staff_id: getCurrentStaffId(),
      staff_name: getCurrentStaffName()
    });
    return response.data;
  },

  checkCanStartNewDay: async () => {
    const response = await axios.get(`${API_BASE_URL}/hotel/F&B/can_start_shift.php`, {
      params: { hotel_code: getHotelCode() }
    });
    return response.data;
  },

  getUnpaidCompletedOrders: async () => {
    const response = await axios.get(`${API_BASE_URL}/hotel/F&B/orders.php`, {
      params: {
        hotel_code: getHotelCode(),
        status: 'completed'
      }
    });
    const orders = response.data.orders || [];
    const payments = await apiService.getPayments();
    const paidOrderIds = new Set((payments.payments || []).map(p => p.order_id));
    const unpaidOrders = orders.filter(o => !paidOrderIds.has(o.id));
    return { success: true, orders: unpaidOrders };
  }
};

const CashierFBMgmt = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:768px)');
  const isTablet = useMediaQuery('(max-width:1024px)');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const [startingNewDay, setStartingNewDay] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [showPreviousShifts, setShowPreviousShifts] = useState(false);
  
  // State management
  const [allOrders, setAllOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [inventoryItems, setInventoryItems] = useState([]);
  const [payments, setPayments] = useState([]);
  const [paymentsSummary, setPaymentsSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [paymentsLoading, setPaymentsLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);

  // Search and Filters
  const [searchQuery, setSearchQuery] = useState('');
  const [dateFilter, setDateFilter] = useState('today');
  const [customDate, setCustomDate] = useState('');
  const [paymentsDateFilter, setPaymentsDateFilter] = useState('today');
  const [statusFilter, setStatusFilter] = useState('all');
  const [typeFilter, setTypeFilter] = useState('all');
  const [showUnpaidOnly, setShowUnpaidOnly] = useState(false);

  // Pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [paymentsPage, setPaymentsPage] = useState(0);
  const [paymentsRowsPerPage, setPaymentsRowsPerPage] = useState(10);

  // Dialog states
  const [openPrintDialog, setOpenPrintDialog] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');
  const [printing, setPrinting] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [openOrderDetailsDialog, setOpenOrderDetailsDialog] = useState(false);
  const [printedOrders, setPrintedOrders] = useState(new Set());
  const [reprintMode, setReprintMode] = useState(false);
  const [existingPaymentMethod, setExistingPaymentMethod] = useState(null);
const [openClosePreviousShift, setOpenClosePreviousShift] = useState(false);
  // Day Closure State
  const [isDayClosed, setIsDayClosed] = useState(false);
  const [closingDay, setClosingDay] = useState(false);
  const [dayClosureSummary, setDayClosureSummary] = useState(null);
  const [openClosureDialog, setOpenClosureDialog] = useState(false);
  const [openCloseDayDialog, setOpenCloseDayDialog] = useState(false);
  const [closureReason, setClosureReason] = useState('');
  const [pendingOrdersCount, setPendingOrdersCount] = useState(0);
  const [unpaidOrdersCount, setUnpaidOrdersCount] = useState(0);
  const [activeOrdersCount, setActiveOrdersCount] = useState(0);
  const [closeConfirmText, setCloseConfirmText] = useState('');
  const [currentShift, setCurrentShift] = useState(null);
  const [lastShiftDate, setLastShiftDate] = useState(null);
  const [pendingStartNewDayDialog, setPendingStartNewDayDialog] = useState(false);
  const [unpaidOrdersList, setUnpaidOrdersList] = useState([]);

  // Recalculate unpaid counts when payments or orders change
 // Replace the existing useEffect with this:
useEffect(() => {
  const today = new Date().toISOString().split('T')[0];
  const paidOrderIds = new Set(payments.map(p => p.order_id));
  
  // Only count today's unpaid completed orders
  const todayUnpaidCompleted = allOrders.filter(o => 
    getDateOnly(o.created_at) === today &&
    o.status === 'completed' && 
    !paidOrderIds.has(o.id)
  );
  
  setUnpaidOrdersCount(todayUnpaidCompleted.length);
  setUnpaidOrdersList(todayUnpaidCompleted);
}, [payments, allOrders]);

  // Load data
  useEffect(() => {
    loadData();
    const interval = setInterval(() => {
      loadOrders();
      if (activeTab === 1) loadPayments();
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  // Apply filters when dependencies change
  useEffect(() => {
    applyFilters();
  }, [allOrders, searchQuery, dateFilter, customDate, statusFilter, typeFilter, showPreviousShifts, isDayClosed, showUnpaidOnly]);

  // Load payments when payments tab is active or date filter changes
  useEffect(() => {
    if (activeTab === 1) {
      loadPayments();
    }
  }, [activeTab, paymentsDateFilter]);

  const loadData = async () => {
    setLoading(true);
    try {
      await Promise.all([loadOrders(), loadInventoryItems(), loadPayments()]);
      await checkDayClosureStatus();
    } catch (error) {
      console.error('Error loading data:', error);
      showSnackbar('Failed to load data: ' + error.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  const loadOrders = async () => {
    try {
      const params = { 
        hotel_code: getHotelCode(),
        current_shift_only: 'false',
        include_history: 'true'
      };
      
      const data = await apiService.getOrders(params);
      if (data.success) {
        setAllOrders(data.orders || []);
      }
    } catch (error) {
      console.error('Error loading orders:', error);
    }
  };

  const loadInventoryItems = async () => {
    try {
      const data = await apiService.getInventoryItems();
      if (data.success) {
        setInventoryItems(data.inventory || []);
      }
    } catch (error) {
      console.error('Error loading inventory items:', error);
    }
  };

  const loadPayments = async () => {
    setPaymentsLoading(true);
    try {
      let dateParam = {};
      const today = new Date().toISOString().split('T')[0];
      
      if (paymentsDateFilter === 'today') {
        dateParam = { start_date: today, end_date: today };
      } else if (paymentsDateFilter === 'week') {
        const weekAgo = new Date();
        weekAgo.setDate(weekAgo.getDate() - 7);
        dateParam = { start_date: weekAgo.toISOString().split('T')[0] };
      } else if (paymentsDateFilter === 'month') {
        const monthAgo = new Date();
        monthAgo.setDate(monthAgo.getDate() - 30);
        dateParam = { start_date: monthAgo.toISOString().split('T')[0] };
      }
      
      const data = await apiService.getPayments(dateParam);
      if (data.success) {
        setPayments(data.payments || []);
        setPaymentsSummary(data.summary);
      }
    } catch (error) {
      console.error('Error loading payments:', error);
    } finally {
      setPaymentsLoading(false);
    }
  };

  const applyFilters = () => {
    let filtered = [...allOrders];

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    // Filter by date
    if (dateFilter === 'today') {
      filtered = filtered.filter(order => {
        const orderDate = new Date(order.created_at);
        orderDate.setHours(0, 0, 0, 0);
        return orderDate.getTime() === today.getTime();
      });
    } else if (dateFilter === 'yesterday') {
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      filtered = filtered.filter(order => {
        const orderDate = new Date(order.created_at);
        orderDate.setHours(0, 0, 0, 0);
        return orderDate.getTime() === yesterday.getTime();
      });
    } else if (dateFilter === 'week') {
      const weekAgo = new Date(today);
      weekAgo.setDate(weekAgo.getDate() - 7);
      filtered = filtered.filter(order => new Date(order.created_at) >= weekAgo);
    } else if (dateFilter === 'month') {
      const monthAgo = new Date(today);
      monthAgo.setDate(monthAgo.getDate() - 30);
      filtered = filtered.filter(order => new Date(order.created_at) >= monthAgo);
    } else if (dateFilter === 'custom' && customDate) {
      const selectedDate = new Date(customDate);
      selectedDate.setHours(0, 0, 0, 0);
      filtered = filtered.filter(order => {
        const orderDate = new Date(order.created_at);
        orderDate.setHours(0, 0, 0, 0);
        return orderDate.getTime() === selectedDate.getTime();
      });
    }

    // Filter by status
    if (statusFilter !== 'all') {
      filtered = filtered.filter(order => order.status === statusFilter);
    }

    // Filter by order type
    if (typeFilter !== 'all') {
      filtered = filtered.filter(order => order.order_type === typeFilter);
    }

    // Filter unpaid completed orders only
    if (showUnpaidOnly) {
      const paidOrderIds = new Set(payments.map(p => p.order_id));
      filtered = filtered.filter(order => 
        order.status === 'completed' && !paidOrderIds.has(order.id)
      );
    }

    // Apply search filter
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(order =>
        order.order_number?.toLowerCase().includes(query) ||
        order.table_number?.toLowerCase().includes(query) ||
        (order.room_number?.toString().toLowerCase().includes(query)) ||
        order.guest_name?.toLowerCase().includes(query)
      );
    }

    // Sort by created_at descending
    filtered.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

    setFilteredOrders(filtered);
    setPage(0);
  };

  const handleRefresh = async () => {
    setRefreshing(true);
    try {
      await loadData();
      showSnackbar('Data refreshed successfully!', 'success');
    } catch (error) {
      showSnackbar('Failed to refresh data', 'error');
    } finally {
      setTimeout(() => setRefreshing(false), 500);
    }
  };

  const handleDateFilterChange = (event) => {
    const newValue = event.target.value;
    setDateFilter(newValue);
    if (newValue !== 'custom') {
      setCustomDate('');
    }
    if (showUnpaidOnly) {
      setShowUnpaidOnly(false);
    }
  };

  const handleClearFilters = () => {
    setSearchQuery('');
    setDateFilter('today');
    setCustomDate('');
    setStatusFilter('all');
    setTypeFilter('all');
    setShowPreviousShifts(false);
    setShowUnpaidOnly(false);
  };

  const handleOpenPrintDialog = async (order) => {
    setSelectedOrder(order);
    setSelectedPaymentMethod('');
    setReprintMode(false);
    setExistingPaymentMethod(null);
    
    const existingPayment = payments.find(p => p.order_id === order.id);
    if (existingPayment) {
      setReprintMode(true);
      setExistingPaymentMethod(existingPayment.payment_method);
    }
    
    setOpenPrintDialog(true);
  };

  const handleClosePrintDialog = () => {
    setOpenPrintDialog(false);
    setSelectedOrder(null);
    setSelectedPaymentMethod('');
    setReprintMode(false);
    setExistingPaymentMethod(null);
  };

  const handlePrintReceipt = async () => {
    if (!reprintMode && !selectedPaymentMethod) {
      showSnackbar('Please select a payment method', 'error');
      return;
    }

    setPrinting(true);

    try {
      let paymentResult = null;
      
      if (!reprintMode) {
        const amountToRecord = selectedPaymentMethod === 'Complimentary' ? 0 : selectedOrder.final_amount;
        
        paymentResult = await apiService.recordPayment(selectedOrder.id, {
          payment_method: selectedPaymentMethod,
          amount: amountToRecord,
          payment_status: 'completed'
        });
        
        if (paymentResult.success && !paymentResult.already_recorded) {
          setPrintedOrders(prev => new Set(prev).add(selectedOrder.id));
          showSnackbar(`Payment recorded successfully! (${selectedPaymentMethod})`, 'success');
          
          // CRITICAL FIX: Reload payments AND orders to update UI
          await loadPayments();
          await loadOrders();
          
          // Force update unpaid orders count
          const updatedUnpaidCount = allOrders.filter(o => 
            o.status === 'completed' && 
            o.id !== selectedOrder.id && 
            !payments.some(p => p.order_id === o.id)
          ).length;
          setUnpaidOrdersCount(updatedUnpaidCount);
          
          await checkDayClosureStatus();
          applyFilters();
          
        } else if (paymentResult.already_recorded) {
          showSnackbar('Payment already recorded - reprinting receipt', 'info');
        }
      }

      const methodToDisplay = reprintMode ? existingPaymentMethod : selectedPaymentMethod;
      await printReceiptWindow(selectedOrder, methodToDisplay, reprintMode);

      showSnackbar(reprintMode ? 'Receipt reprinted successfully!' : 'Receipt printed successfully!', 'success');
      handleClosePrintDialog();
    } catch (error) {
      console.error('Error printing receipt:', error);
      showSnackbar('Failed to print receipt: ' + (error.response?.data?.error || error.message), 'error');
    } finally {
      setPrinting(false);
    }
  };

const printReceiptWindow = (order, paymentMethod, isReprint = false) => {
  return new Promise((resolve) => {
    const isComplimentary = paymentMethod === 'Complimentary';
    const paymentMethodDisplay = isComplimentary ? 'COMPLIMENTARY (NO PAYMENT)' : paymentMethod?.toUpperCase() || 'PENDING';
    
    const orderTypeObj = ORDER_TYPES.find(ot => ot.value === order.order_type);
    const orderTypeLabel = orderTypeObj?.label || order.order_type;
    const roomDisplay = order.room_number ? `Room ${order.room_number}${order.room_name ? ` - ${order.room_name}` : ''}` : '';
    
    // Get waiter/server name
    const waiterName = order.served_by_name || 
                       (order.served_by ? `${order.served_by_first_name || ''} ${order.served_by_other_names || ''}`.trim() : null) || 
                       order.created_by_name ||
                       (order.created_by ? `${order.created_by_first_name || ''} ${order.created_by_other_names || ''}`.trim() : null) ||
                       'N/A';
    
    const cashierName = getCurrentStaffName();
    
    const printWindow = window.open('', '_blank', 'width=450,height=700,toolbar=yes,scrollbars=yes');
    
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Receipt - ${order.order_number}</title>
        <style>
          /* THERMAL PRINTER OPTIMIZED STYLES - BOLD & DARK */
          * { 
            margin: 0; 
            padding: 0; 
            box-sizing: border-box; 
          }
          body {
            font-family: 'Courier New', 'Consolas', monospace;
            font-size: 13px;
            font-weight: bold;
            line-height: 1.6;
            margin: 0;
            padding: 12px;
            width: 280px;
            margin: 0 auto;
            background: white;
            color: #000000;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          @media print {
            body { 
              margin: 0; 
              padding: 8px; 
              font-size: 12px;
            }
            .no-print { display: none; }
          }
          .header {
            text-align: center;
            border-bottom: 3px solid #000;
            padding-bottom: 10px;
            margin-bottom: 12px;
          }
          .hotel-name {
            font-size: 20px;
            font-weight: 900;
            letter-spacing: 2px;
            color: #000;
          }
          .hotel-address {
            font-size: 11px;
            color: #000;
            margin-top: 3px;
            font-weight: bold;
          }
          .receipt-type {
            font-size: 15px;
            font-weight: 900;
            color: #000;
            margin: 8px 0;
            text-transform: uppercase;
            letter-spacing: 1px;
          }
          .reprint-badge {
            background-color: #000;
            color: #fff;
            padding: 4px 12px;
            border-radius: 4px;
            font-size: 11px;
            display: inline-block;
            margin-top: 5px;
            font-weight: 900;
            letter-spacing: 1px;
          }
          .order-info {
            margin-bottom: 10px;
            border-bottom: 2px solid #000;
            padding-bottom: 8px;
          }
          .order-info-row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 3px;
            font-weight: bold;
          }
          .order-info-label {
            font-weight: 900;
            color: #000;
          }
          .order-info-value {
            font-weight: bold;
            color: #000;
          }
          .items-header {
            display: flex;
            justify-content: space-between;
            font-weight: 900;
            border-bottom: 2px solid #000;
            padding: 6px 0;
            margin-top: 8px;
            background-color: #000;
            color: #fff;
          }
          .items-header span {
            font-weight: 900;
            color: #fff;
          }
          .item-row {
            display: flex;
            justify-content: space-between;
            padding: 5px 0;
            border-bottom: 1px dotted #000;
            font-weight: bold;
          }
          .item-name {
            flex: 2;
            word-break: break-word;
            font-weight: bold;
          }
          .item-qty {
            flex: 0.5;
            text-align: center;
            font-weight: bold;
          }
          .item-price {
            flex: 1;
            text-align: right;
            font-weight: bold;
          }
          .item-total {
            flex: 1;
            text-align: right;
            font-weight: bold;
          }
          .breakdown {
            border-top: 2px solid #000;
            padding-top: 8px;
            margin-top: 8px;
          }
          .breakdown-row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 3px;
            font-weight: bold;
            padding: 2px 0;
          }
          .total {
            border-top: 3px solid #000;
            padding-top: 8px;
            margin-top: 5px;
            font-weight: 900;
            font-size: 16px;
            display: flex;
            justify-content: space-between;
            color: #000;
          }
          .total span {
            font-weight: 900;
          }
          .payment-method {
            text-align: center;
            margin: 15px 0;
            padding: 12px;
            background-color: ${isComplimentary ? '#000' : '#000'};
            border-radius: 4px;
            font-weight: 900;
            font-size: 14px;
            border: 2px solid #000;
            color: ${isComplimentary ? '#fff' : '#fff'};
          }
          .payment-method .method-text {
            color: #fff;
            font-weight: 900;
          }
          .complimentary-note {
            color: #FFD700;
            font-size: 12px;
            margin-top: 5px;
            font-weight: bold;
          }
          .staff-info {
            margin: 10px 0;
            padding: 10px 12px;
            background-color: #000;
            border-radius: 4px;
            border: 2px solid #000;
            font-size: 12px;
          }
          .staff-info-row {
            display: flex;
            justify-content: space-between;
            padding: 3px 0;
            font-weight: bold;
          }
          .staff-label {
            font-weight: 900;
            color: #FFD700;
          }
          .staff-name {
            color: #fff;
            font-weight: 900;
          }
          .footer {
            text-align: center;
            border-top: 2px solid #000;
            padding-top: 10px;
            margin-top: 12px;
            font-size: 10px;
            font-weight: bold;
          }
          .special-instructions {
            margin: 10px 0;
            padding: 10px;
            background-color: #000;
            border-radius: 4px;
            font-size: 11px;
            color: #fff;
            border: 2px solid #000;
          }
          .special-instructions strong {
            color: #FFD700;
          }
          .special-instructions br {
            color: #fff;
          }
          .cashier-signature {
            margin-top: 15px;
            padding-top: 10px;
            border-top: 2px solid #000;
            font-size: 11px;
            font-weight: bold;
          }
          .signature-line {
            margin-top: 8px;
            display: flex;
            justify-content: space-between;
            font-weight: bold;
            padding: 2px 0;
          }
          .watermark {
            position: fixed;
            bottom: 20px;
            right: 20px;
            opacity: 0.05;
            font-size: 40px;
            font-weight: 900;
            transform: rotate(-15deg);
            pointer-events: none;
          }
          .thank-you {
            text-align: center;
            margin: 12px 0;
            font-weight: 900;
            font-size: 13px;
            color: #000;
          }
          .divider-dash {
            border: none;
            border-top: 2px dashed #000;
            margin: 8px 0;
          }
          .divider-double {
            border: none;
            border-top: 3px double #000;
            margin: 8px 0;
          }
          /* Ensure everything is black on white for thermal printers */
          .black-bg {
            background-color: #000;
            color: #fff;
          }
          .white-text {
            color: #fff;
          }
          .gold-text {
            color: #FFD700;
          }
        </style>
      </head>
      <body>
        <div class="header">
          <div class="hotel-name">${HOTEL_NAME}</div>
          <div class="hotel-address">Food & Beverage Service</div>
          <div class="receipt-type">★ CASHIER RECEIPT ★</div>
          ${isReprint ? '<div class="reprint-badge">*** REPRINT ***</div>' : ''}
        </div>
        
        <div class="order-info">
          <div class="order-info-row">
            <span class="order-info-label">Order #:</span>
            <span class="order-info-value">${order.order_number}</span>
          </div>
          <div class="order-info-row">
            <span class="order-info-label">Date:</span>
            <span class="order-info-value">${formatDate(order.created_at)}</span>
          </div>
          <div class="order-info-row">
            <span class="order-info-label">Type:</span>
            <span class="order-info-value">${orderTypeLabel}</span>
          </div>
          ${order.table_number ? `<div class="order-info-row"><span class="order-info-label">Table:</span><span class="order-info-value">${order.table_number}</span></div>` : ''}
          ${roomDisplay ? `<div class="order-info-row"><span class="order-info-label">Room:</span><span class="order-info-value">${roomDisplay}</span></div>` : ''}
          ${order.guest_name && order.guest_name !== 'Walk-in Customer' ? `<div class="order-info-row"><span class="order-info-label">Guest:</span><span class="order-info-value">${order.guest_name}</span></div>` : ''}
          ${order.guest_phone ? `<div class="order-info-row"><span class="order-info-label">Phone:</span><span class="order-info-value">${order.guest_phone}</span></div>` : ''}
        </div>
        
        <!-- STAFF INFORMATION SECTION -->
        <div class="staff-info">
          <div class="staff-info-row">
            <span class="staff-label">👨‍🍳 Waiter/Server:</span>
            <span class="staff-name">${waiterName}</span>
          </div>
          <div class="staff-info-row">
            <span class="staff-label">💰 Cashier:</span>
            <span class="staff-name">${cashierName}</span>
          </div>
          ${order.created_by_name && order.created_by_name !== waiterName && order.created_by_name !== cashierName ? `
            <div class="staff-info-row">
              <span class="staff-label">📝 Order Taken By:</span>
              <span class="staff-name">${order.created_by_name}</span>
            </div>
          ` : ''}
        </div>
        
        <hr class="divider-dash">
        
        <div class="items-header">
          <span class="item-name">Item</span>
          <span class="item-qty">Qty</span>
          <span class="item-price">Price</span>
          <span class="item-total">Total</span>
        </div>
        ${order.items?.map(item => `
          <div class="item-row">
            <span class="item-name">${item.item_name}</span>
            <span class="item-qty">${item.quantity}</span>
            <span class="item-price">₦${parseFloat(item.unit_price).toFixed(2)}</span>
            <span class="item-total">₦${(item.quantity * item.unit_price).toFixed(2)}</span>
          </div>
        `).join('')}
        
        <hr class="divider-dash">
        
        <div class="breakdown">
          <div class="breakdown-row">
            <span>Subtotal:</span>
            <span>₦${parseFloat(order.total_amount || 0).toFixed(2)}</span>
          </div>
          ${TAX_RATE > 0 ? `
            <div class="breakdown-row">
              <span>Tax (${TAX_RATE}%):</span>
              <span>₦${parseFloat(order.tax_amount || 0).toFixed(2)}</span>
            </div>
          ` : ''}
          ${order.order_type === 'room_service' && parseFloat(order.service_charge || 0) > 0 ? `
            <div class="breakdown-row">
              <span>Service Charge (${SERVICE_CHARGE_RATE}%):</span>
              <span>₦${parseFloat(order.service_charge || 0).toFixed(2)}</span>
            </div>
          ` : ''}
        </div>
        
        <div class="total">
          <span>TOTAL:</span>
          <span>₦${parseFloat(order.final_amount || 0).toFixed(2)}</span>
        </div>
        
        <div class="payment-method">
          <span class="method-text">PAYMENT: ${paymentMethodDisplay}</span>
          ${isComplimentary ? '<div class="complimentary-note">★ Complimentary - No Payment Required ★</div>' : ''}
        </div>
        
        ${order.special_instructions ? `
          <div class="special-instructions">
            <strong>📝 Special Instructions:</strong><br>
            ${order.special_instructions}
          </div>
        ` : ''}
        
        <hr class="divider-double">
        
        <div class="cashier-signature">
          <div class="signature-line">
            <span>Customer Signature: ___________________</span>
          </div>
          <div class="signature-line">
            <span>Waiter/Server: ${waiterName}</span>
          </div>
          <div class="signature-line">
            <span>Cashier: ${cashierName}</span>
          </div>
        </div>
        
        <div class="thank-you">
          ★ Thank you for choosing ${HOTEL_NAME}! ★
        </div>
        
        <div class="footer">
          This is a computer generated receipt<br>
          Please retain for your records<br>
          ${new Date().toLocaleString()}
        </div>
        
        <div class="watermark">${HOTEL_NAME}</div>
        
        <script>
          window.onload = function() {
            setTimeout(function() {
              window.print();
              setTimeout(function() {
                window.close();
              }, 500);
            }, 300);
          }
        <\/script>
      </body>
      </html>
    `);
    printWindow.document.close();
    
    const checkPrint = setInterval(() => {
      if (printWindow.closed) {
        clearInterval(checkPrint);
        resolve();
      }
    }, 500);
  });
};




  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  // Day Closure Functions
 const checkDayClosureStatus = async () => {
  try {
    const response = await apiService.getCurrentShift();
    console.log('Shift API response:', response);
    
    const dayClosed = response.is_day_closed || response.data?.is_day_closed || false;
    setIsDayClosed(dayClosed);
    setCurrentShift(response.active_shift || response.data?.active_shift);
    
    if (response.last_shift_date) {
      setLastShiftDate(response.last_shift_date);
    }
    
    const today = new Date().toISOString().split('T')[0];
    const paidOrderIds = new Set(payments.map(p => p.order_id));
    
    // Get today's orders only
    const todayOrders = allOrders.filter(o => 
      getDateOnly(o.created_at) === today
    );
    
    // Calculate today's counts
    const todayActiveOrders = todayOrders.filter(o => 
      ['pending', 'confirmed', 'preparing', 'ready', 'served'].includes(o.status)
    ).length;
    
    const todayUnpaidOrders = todayOrders.filter(o => 
      o.status === 'completed' && !paidOrderIds.has(o.id)
    ).length;
    
    const todayPendingOrders = todayOrders.filter(o => 
      o.status === 'pending'
    ).length;
    
    setActiveOrdersCount(todayActiveOrders);
    setUnpaidOrdersCount(todayUnpaidOrders);  // ← This now matches the useEffect
    setPendingOrdersCount(todayPendingOrders);
    
    console.log('Today\'s counts:', {
      today,
      todayActiveOrders,
      todayUnpaidOrders,
      todayPendingOrders,
      totalOrders: allOrders.length,
      todayOrdersCount: todayOrders.length
    });
    
  } catch (error) {
    console.error('Error checking day closure:', error);
    setIsDayClosed(false);
  }
};

  const canCloseDay = () => {
    if (isDayClosed) return false;
    if (!currentShift) return false;
    return activeOrdersCount === 0 && unpaidOrdersCount === 0;
  };

  const canStartNewDay = async () => {
    const canStartData = await apiService.checkCanStartNewDay();
    if (!canStartData.can_start) {
      if (canStartData.has_unpaid_orders) {
        setUnpaidOrdersList(canStartData.unpaid_orders || []);
        setUnpaidOrdersCount(canStartData.unpaid_orders?.length || 0);
        setPendingStartNewDayDialog(true);
        showSnackbar(`⚠️ Cannot start new day. ${canStartData.unpaid_orders?.length || 0} unpaid completed order(s) need payment recording.`, 'error');
      } else if (canStartData.has_pending_orders) {
        showSnackbar(`⚠️ Cannot start new day. ${canStartData.pending_orders?.length || 0} pending order(s) need completion.`, 'error');
      } else {
        showSnackbar(canStartData.reasons?.join('\n') || 'Cannot start new day', 'error');
      }
      return false;
    }
    return true;
  };

  const handleStartNewDay = async () => {
    setStartingNewDay(true);
    try {
      const canStartData = await apiService.checkCanStartNewDay();
      
      if (!canStartData.can_start) {
        if (canStartData.has_unpaid_orders) {
          setUnpaidOrdersList(canStartData.unpaid_orders || []);
          setPendingStartNewDayDialog(true);
          showSnackbar(`⚠️ Cannot start new day. ${canStartData.unpaid_orders?.length || 0} unpaid completed order(s) need payment recording.`, 'error');
        } else if (canStartData.has_pending_orders) {
          showSnackbar(`⚠️ Cannot start new day. ${canStartData.pending_orders?.length || 0} pending order(s) need completion.`, 'error');
        } else {
          showSnackbar(canStartData.reasons?.join('\n') || 'Cannot start new day', 'error');
        }
        setStartingNewDay(false);
        return;
      }
      
      const response = await apiService.startNewDay();
      
      if (response.success) {
        showSnackbar(response.message || '✅ New day started successfully! You can now process orders.', 'success');
        setIsDayClosed(false);
        setShowPreviousShifts(false);
        await loadData();
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        showSnackbar(response.error || 'Failed to start new day', 'error');
      }
    } catch (error) {
      console.error('Error starting new day:', error);
      showSnackbar(error.response?.data?.error || error.message, 'error');
    } finally {
      setStartingNewDay(false);
    }
  };

  const handleCloseDay = async () => {
    if (isDayClosed) {
      showSnackbar('Day is already closed. Please start a new day first.', 'error');
      setOpenCloseDayDialog(false);
      return;
    }
    
    if (!canCloseDay()) {
      if (activeOrdersCount > 0) {
        showSnackbar(`Cannot close day. You have ${activeOrdersCount} active order(s) that need to be completed or cancelled first.`, 'error');
      } else if (unpaidOrdersCount > 0) {
        showSnackbar(`Cannot close day. You have ${unpaidOrdersCount} completed order(s) without payment recorded. Please print receipts first.`, 'error');
        setPendingStartNewDayDialog(true);
      }
      return;
    }
    
    setClosingDay(true);
    
    try {
      const response = await apiService.closeDay(closureReason);
      
      if (response.success) {
        setDayClosureSummary(response.closure);
        setIsDayClosed(true);
        setOpenClosureDialog(true);
        showSnackbar(`✅ Day closed successfully! Total revenue: ${formatCurrency(response.closure.total_revenue)}`, 'success');
        await loadOrders();
        await loadPayments();
      } else {
        showSnackbar(response.error || 'Failed to close day', 'error');
      }
    } catch (error) {
      console.error('Error closing day:', error);
      showSnackbar(error.response?.data?.error || error.message, 'error');
    } finally {
      setClosingDay(false);
      setOpenCloseDayDialog(false);
    }
  };

  const toggleShowPreviousShifts = () => {
    const newValue = !showPreviousShifts;
    setShowPreviousShifts(newValue);
    if (newValue) {
      setDateFilter('week');
    } else {
      setDateFilter('today');
    }
    setPage(0);
  };

  const handleShowUnpaidOnly = () => {
    setShowUnpaidOnly(true);
    setDateFilter('custom');
    setCustomDate('');
    setStatusFilter('completed');
    setPage(0);
  };

  // Calculate statistics
  const getDisplayStatistics = () => {
    const completedOrders = filteredOrders.filter(o => o.status === 'completed');
    
    const totalRevenue = payments
      .filter(p => p.payment_method !== 'Complimentary')
      .reduce((sum, payment) => sum + (parseFloat(payment.amount) || 0), 0);
      
    const totalOrders = filteredOrders.length;
    const completedCount = completedOrders.length;
    
    const today = new Date().toISOString().split('T')[0];
    const pendingCount = filteredOrders.filter(o => 
      o.status === 'pending' && getDateOnly(o.created_at) === today
    ).length;
    const confirmedCount = filteredOrders.filter(o => 
      o.status === 'confirmed' && getDateOnly(o.created_at) === today
    ).length;
    const preparingCount = filteredOrders.filter(o => 
      o.status === 'preparing' && getDateOnly(o.created_at) === today
    ).length;
    const readyCount = filteredOrders.filter(o => 
      o.status === 'ready' && getDateOnly(o.created_at) === today
    ).length;
    const servedCount = filteredOrders.filter(o => 
      o.status === 'served' && getDateOnly(o.created_at) === today
    ).length;
    const cancelledCount = filteredOrders.filter(o => o.status === 'cancelled').length;
    const averageOrderValue = completedCount > 0 ? totalRevenue / completedCount : 0;

    return { totalRevenue, totalOrders, completedCount, pendingCount, confirmedCount, preparingCount, readyCount, servedCount, cancelledCount, averageOrderValue };
  };
  
  const stats = getDisplayStatistics();

  const statCards = [
    { title: 'Total Revenue', value: formatCurrency(stats.totalRevenue), icon: <AttachMoney />, color: '#4CAF50', tooltip: 'From completed orders only' },
    { title: 'Total Orders', value: stats.totalOrders, icon: <Receipt />, color: '#1976D2', tooltip: 'All orders in this period' },
    { title: 'Completed', value: stats.completedCount, icon: <CheckCircle />, color: '#388E3C', tooltip: 'Successfully completed orders' },
    { title: 'Active Orders', value: stats.pendingCount + stats.confirmedCount + stats.preparingCount + stats.readyCount + stats.servedCount, icon: <HourglassEmpty />, color: '#FF9800', tooltip: 'Pending, Confirmed, Preparing, Ready, Served' },
    { title: 'Cancelled', value: stats.cancelledCount, icon: <Cancel />, color: '#D32F2F', tooltip: 'Cancelled orders' },
  ];

  const paginatedOrders = filteredOrders.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const totalPages = Math.ceil(filteredOrders.length / rowsPerPage);
  const paginatedPayments = payments.slice(paymentsPage * paymentsRowsPerPage, paymentsPage * paymentsRowsPerPage + paymentsRowsPerPage);
  const totalPaymentsPages = Math.ceil(payments.length / paymentsRowsPerPage);

  const getOrderTypeIcon = (orderType) => {
    const type = ORDER_TYPES.find(t => t.value === orderType);
    return type?.icon || <Restaurant />;
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'completed': return <CheckCircle fontSize="small" />;
      case 'cancelled': return <Cancel fontSize="small" />;
      case 'pending': return <HourglassEmpty fontSize="small" />;
      case 'confirmed': return <CheckCircleOutline fontSize="small" />;
      case 'preparing': return <Kitchen fontSize="small" />;
      case 'ready': return <DoneAll fontSize="small" />;
      case 'served': return <EmojiEmotions fontSize="small" />;
      default: return <Schedule fontSize="small" />;
    }
  };

  // Render Orders Tab
  const renderOrdersTab = () => {
    return (
      <Box>
        {/* Day Closure Status Alert */}
     
{/* Day Closure Status Alert */}
{isDayClosed ? (
  <Alert 
    severity="error" 
    sx={{ mb: 3 }} 
    icon={<WarningAmber />}
    action={
      <Stack direction="row" spacing={1}>
        <Button 
          color="inherit" 
          size="small" 
          onClick={handleStartNewDay}
          disabled={startingNewDay}
          startIcon={startingNewDay ? <CircularProgress size={16} /> : <PlayArrow />}
          sx={{ 
            backgroundColor: 'rgba(255,255,255,0.2)',
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.3)' }
          }}
        >
          {startingNewDay ? 'Starting...' : 'Start New Day'}
        </Button>
        <Button
          color="inherit"
          size="small"
          onClick={toggleShowPreviousShifts}
          startIcon={<HistoryIcon />}
          variant={showPreviousShifts ? "contained" : "outlined"}
          sx={{ 
            backgroundColor: showPreviousShifts ? 'rgba(255,255,255,0.3)' : 'transparent',
            borderColor: 'rgba(255,255,255,0.5)'
          }}
        >
          {showPreviousShifts ? 'Hide History' : 'Show History'}
        </Button>
        {/* ADD THIS BUTTON HERE */}
        <Button
          color="warning"
          size="small"
          onClick={() => setOpenClosePreviousShift(true)}
          startIcon={<History />}
          variant="contained"
          sx={{ 
            backgroundColor: '#FF9800',
            '&:hover': { backgroundColor: '#F57C00' }
          }}
        >
          Close Previous Shift
        </Button>
      </Stack>
    }
  >
    <Typography variant="body2">
      <strong>⚠️ DAY IS CLOSED!</strong> No new orders can be processed. 
      {!showPreviousShifts && " Showing only today's orders. "}
      {showPreviousShifts && " Showing all historical orders. "}
      Click "Start New Day" to begin operations for today.
    </Typography>
    {dayClosureSummary && (
      <Button size="small" color="inherit" onClick={() => setOpenClosureDialog(true)} sx={{ mt: 1 }}>
        View Summary
      </Button>
    )}
  </Alert>
) : (
  <Alert 
    severity={
      !currentShift ? "warning" : 
      (unpaidOrdersCount > 0 ? "error" : 
      (pendingOrdersCount > 0 ? "warning" : "success"))
    } 
    sx={{ mb: 3 }} 
    icon={
      !currentShift ? <LockClock /> : 
      (unpaidOrdersCount > 0 ? <WarningAmber /> : 
      (pendingOrdersCount > 0 ? <HourglassEmpty /> : <CheckCircle />))
    }
    action={
      <Stack direction="row" spacing={1}>
        {!currentShift ? (
          <Button 
            color="inherit" 
            size="small" 
            onClick={handleStartNewDay}
            disabled={startingNewDay}
            startIcon={startingNewDay ? <CircularProgress size={16} /> : <PlayArrow />}
            sx={{ 
              backgroundColor: 'rgba(255,255,255,0.2)',
              '&:hover': { backgroundColor: 'rgba(255,255,255,0.3)' }
            }}
          >
            {startingNewDay ? 'Starting...' : 'Start New Day'}
          </Button>
        ) : (
          <CloseDayButton 
            variant="contained"
            onClick={() => setOpenCloseDayDialog(true)}
            disabled={!canCloseDay() || closingDay}
            canclose={canCloseDay()}
            startIcon={closingDay ? <CircularProgress size={20} /> : <LockClock />}
          >
            {closingDay ? 'Closing Day...' : '🔒 Close Day'}
          </CloseDayButton>
        )}
        {/* ADD THIS BUTTON HERE FOR BOTH SCENARIOS */}
        <Button
          variant="outlined"
          color="warning"
          size="small"
          onClick={() => setOpenClosePreviousShift(true)}
          startIcon={<History />}
          sx={{ 
            borderColor: '#FF9800',
            color: '#FF9800',
            '&:hover': { 
              backgroundColor: 'rgba(255,152,0,0.1)',
              borderColor: '#F57C00'
            }
          }}
        >
          Close Previous Shift
        </Button>
      </Stack>
    }
  >
    <Typography variant="body2">
      {!currentShift ? (
        <>
          <strong>⚠️ No Active Shift!</strong> Please start a new day to begin operations.
        </>
      ) : (
        <>
          <strong>End of Day Status:</strong>
          {pendingOrdersCount > 0 && (
            <span style={{ marginLeft: '8px' }}>
              ⚠️ <strong>{pendingOrdersCount}</strong> active order(s) need completion.
            </span>
          )}
          {unpaidOrdersCount > 0 && (
            <span style={{ marginLeft: '8px' }}>
              ⚠️ <strong>{unpaidOrdersCount}</strong> completed order(s) need payment recording.
            </span>
          )}
          {canCloseDay() && !pendingOrdersCount && !unpaidOrdersCount && (
            <span style={{ marginLeft: '8px' }}> ✅ Ready to close day.</span>
          )}
        </>
      )}
    </Typography>
  </Alert>
)}

{/* ALSO ADD A FLOATING ACTION BUTTON FOR BETTER VISIBILITY - Add this after the Alert section */}
<Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}>
  {/* <Button
    variant="contained"
    color="warning"
    startIcon={<History />}
    onClick={() => setOpenClosePreviousShift(true)}
    sx={{ 
      borderRadius: 2,
      boxShadow: 3,
      background: 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)',
      '&:hover': { 
        transform: 'translateY(-2px)',
        boxShadow: 5,
        background: 'linear-gradient(135deg, #F57C00 0%, #E65100 100%)'
      }
    }}
  >
    📅 Close Previous Shift
  </Button> */}
</Box>
        {/* Unpaid Completed Orders Alert
        {!isDayClosed && currentShift && unpaidOrdersCount > 0 && (
          <Alert 
            severity="error" 
            sx={{ mb: 3 }}
            icon={<WarningAmber />}
            action={
              <Stack direction="row" spacing={1}>
                <Button 
                  color="inherit" 
                  size="small" 
                  onClick={handleShowUnpaidOnly}
                  startIcon={<PaymentIcon />}
                >
                  View {unpaidOrdersCount} Unpaid Orders
                </Button>
                <Button 
                  color="inherit" 
                  size="small" 
                  onClick={async () => {
                    await loadPayments();
                    await loadOrders();
                    await checkDayClosureStatus();
                    showSnackbar('Data refreshed!', 'success');
                  }}
                  startIcon={<Refresh />}
                >
                  Refresh
                </Button>
<Button
  variant="outlined"
  color="warning"
  startIcon={<History />}
  onClick={() => setOpenClosePreviousShift(true)}
  sx={{ mr: 1 }}
>
  Close Previous Shift
</Button>
                
              </Stack>
            }
          >
            <Typography variant="body2">
              <strong>⚠️ {unpaidOrdersCount} completed order(s) without payment!</strong> 
              Please print receipts and record payments for these orders. 
              These orders are blocking day closure.
            </Typography>
          </Alert>
        )} */}

        {/* Show Previous Shifts Toggle
        {!isDayClosed && (
          <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
            <Button
              variant={showPreviousShifts ? "contained" : "outlined"}
              size="small"
              onClick={toggleShowPreviousShifts}
              startIcon={<HistoryIcon />}
              sx={{ borderRadius: 20 }}
            >
              {showPreviousShifts ? 'Hide Previous Shifts' : 'Show Previous Shifts'}
            </Button>
            {showUnpaidOnly && (
              <Chip 
                label="Showing Unpaid Completed Orders Only" 
                size="small" 
                color="error" 
                icon={<WarningAmber />}
                onDelete={() => setShowUnpaidOnly(false)}
              />
            )}
          </Box>
        )} */}

        {/* Statistics Cards Row */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          {statCards.map((stat, index) => (
            <Grid item xs={12} sm={6} md={2.4} key={index}>
              <Zoom in timeout={index * 100}>
                <StatCard>
                  <CardContent sx={{ py: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <Box sx={{ flex: 1 }}>
                        <Typography variant="h5" fontWeight="bold" sx={{ color: stat.color }}>
                          {stat.value}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
                          {stat.title}
                        </Typography>
                        <Typography variant="caption" color="textSecondary" sx={{ fontSize: '10px' }}>
                          {stat.tooltip}
                        </Typography>
                      </Box>
                      <Avatar sx={{ bgcolor: stat.color, width: 48, height: 48 }}>
                        {stat.icon}
                      </Avatar>
                    </Box>
                  </CardContent>
                </StatCard>
              </Zoom>
            </Grid>
          ))}
        </Grid>

        {/* Search and Filters */}
        <Paper elevation={1} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                placeholder="Search by order number, table, room, or guest name..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                size="small"
                InputProps={{
                  startAdornment: (<InputAdornment position="start"><Search color="action" /></InputAdornment>),
                }}
              />
            </Grid>
            <Grid item xs={6} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Date</InputLabel>
                <Select value={dateFilter} onChange={handleDateFilterChange} label="Date" startAdornment={<CalendarToday fontSize="small" sx={{ mr: 1 }} />}>
                  <MenuItem value="today">Today</MenuItem>
                  <MenuItem value="yesterday">Yesterday</MenuItem>
                  <MenuItem value="week">Last 7 Days</MenuItem>
                  <MenuItem value="month">Last 30 Days</MenuItem>
                  <MenuItem value="custom">Custom Date</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {dateFilter === 'custom' && (
              <Grid item xs={6} md={2}>
                <TextField fullWidth size="small" type="date" label="Select Date" value={customDate} onChange={(e) => setCustomDate(e.target.value)} InputLabelProps={{ shrink: true }} />
              </Grid>
            )}
            <Grid item xs={6} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Status</InputLabel>
                <Select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} label="Status">
                  <MenuItem value="all">All Status</MenuItem>
                  <MenuItem value="pending">Pending</MenuItem>
                  <MenuItem value="confirmed">Confirmed</MenuItem>
                  <MenuItem value="preparing">Preparing</MenuItem>
                  <MenuItem value="ready">Ready</MenuItem>
                  <MenuItem value="served">Served</MenuItem>
                  <MenuItem value="completed">Completed</MenuItem>
                  <MenuItem value="cancelled">Cancelled</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Type</InputLabel>
                <Select value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)} label="Type">
                  <MenuItem value="all">All Types</MenuItem>
                  <MenuItem value="dine_in">Bar/Skyline</MenuItem>
                  <MenuItem value="Lounge">Lounge/Arena</MenuItem>
                  <MenuItem value="room_service">Room Service</MenuItem>
                  <MenuItem value="takeaway">Takeaway</MenuItem>
                  <MenuItem value="delivery">Delivery</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={12}>
              <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                <Button variant="outlined" startIcon={<Refresh />} onClick={handleRefresh} disabled={loading} size="small">Refresh</Button>
                {(searchQuery || dateFilter !== 'today' || customDate || statusFilter !== 'all' || typeFilter !== 'all' || showPreviousShifts || showUnpaidOnly) && (
                  <Button variant="text" color="error" onClick={handleClearFilters} startIcon={<Clear />} size="small">Clear All Filters</Button>
                )}
              </Box>
            </Grid>
          </Grid>
          
          <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
            <Chip label={`Showing ${filteredOrders.length} orders`} size="small" color="primary" variant="outlined" />
            {dateFilter === 'today' && (<Chip label={new Date().toLocaleDateString()} size="small" icon={<CalendarToday />} />)}
            {dateFilter === 'yesterday' && (<Chip label="Yesterday" size="small" icon={<CalendarToday />} />)}
            {statusFilter !== 'all' && (<Chip label={`Status: ${statusFilter}`} size="small" onDelete={() => setStatusFilter('all')} />)}
            {typeFilter !== 'all' && (<Chip label={`Type: ${typeFilter}`} size="small" onDelete={() => setTypeFilter('all')} />)}
            {showPreviousShifts && (<Chip label="Showing History" size="small" color="info" icon={<HistoryIcon />} onDelete={() => setShowPreviousShifts(false)} />)}
            {showUnpaidOnly && (<Chip label="Unpaid Completed Only" size="small" color="error" icon={<WarningAmber />} onDelete={() => setShowUnpaidOnly(false)} />)}
            {isDayClosed && !showPreviousShifts && (<Chip label="Current Day Only" size="small" color="warning" />)}
          </Box>
        </Paper>

        {/* Orders List */}
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
            <CircularProgress size={60} />
          </Box>
        ) : (
          <>
            <Grid container spacing={3}>
              {paginatedOrders.length === 0 ? (
                <Grid item xs={12}>
                  <Paper sx={{ p: 8, textAlign: 'center', borderRadius: 3 }}>
                    <ReceiptLong sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
                    <Typography variant="h5" color="textSecondary" gutterBottom>No Orders Found</Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                      {searchQuery ? 'Try adjusting your search criteria' : 
                       showUnpaidOnly ? 'No unpaid completed orders found' :
                       (isDayClosed && !showPreviousShifts ? 'No orders for today. Start a new day to begin operations.' :
                       (dateFilter === 'today' ? 'No orders for today' : 'No orders found for the selected period'))}
                    </Typography>
                    {isDayClosed && !showPreviousShifts && (
                      <Button variant="contained" startIcon={<PlayArrow />} onClick={handleStartNewDay} disabled={startingNewDay} sx={{ mr: 2 }}>
                        {startingNewDay ? 'Starting...' : 'Start New Day'}
                      </Button>
                    )}
                    <Button variant="outlined" startIcon={<Refresh />} onClick={handleRefresh}>Refresh</Button>
                  </Paper>
                </Grid>
              ) : (
                paginatedOrders.map((order, index) => {
                  const isCompleted = order.status === 'completed';
                  const orderTypeIcon = getOrderTypeIcon(order.order_type);
                  const hasPayment = payments.some(p => p.order_id === order.id);
                  const paidAmount = payments.find(p => p.order_id === order.id)?.amount || 0;
                  const isActiveOrder = ['pending', 'confirmed', 'preparing', 'ready', 'served'].includes(order.status);
                  const isUnpaidCompleted = isCompleted && !hasPayment;
                  const orderDate = getDateOnly(order.created_at);
                  const isPastOrder = orderDate < new Date().toISOString().split('T')[0];
                  
                  return (
                    <Grid item xs={12} md={6} lg={4} key={order.id}>
                      <Grow in timeout={index * 100}>
                        <OrderCard status={order.status}>
                          <CardContent>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                              <Box>
                                <Typography variant="h6" fontWeight="bold" gutterBottom>
                                  Order #{order.order_number}
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 1 }}>
                                  <Chip icon={orderTypeIcon} label={order.order_type === 'dine_in' ? 'Bar' : order.order_type === 'Lounge' ? 'Lounge' : order.order_type === 'room_service' ? 'Room Svc' : order.order_type} size="small" variant="outlined" />
                                  {order.table_number && (<Chip label={`Table ${order.table_number}`} size="small" icon={<TableRestaurant />} />)}
                                  {order.room_number && (<Chip label={`Room ${order.room_number}`} size="small" icon={<LocalHotel />} />)}
                                  {isPastOrder && (
                                    <Chip label={`${orderDate}`} size="small" color="warning" variant="outlined" />
                                  )}
                                </Box>
                                <Typography variant="caption" color="textSecondary">
                                  {formatDate(order.created_at)}
                                </Typography>
                              </Box>
                              <StatusBadge status={order.status}>
                                {getStatusIcon(order.status)}
                                {order.status.toUpperCase()}
                              </StatusBadge>
                            </Box>


{/* Add the waiter/server names here */}
{order.served_by_name && (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1, mb: 1 }}>
    <EmojiEmotions fontSize="small" color="action" />
    <Typography variant="caption" color="textSecondary">
      Served by: <strong>{order.served_by_name}</strong>
    </Typography>
  </Box>
)}
{!order.served_by_name && order.created_by_name && (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1, mb: 1 }}>
    <Person fontSize="small" color="action" />
    <Typography variant="caption" color="textSecondary">
      Taken by: <strong>{order.created_by_name}</strong>
    </Typography>
  </Box>
)}

{hasPayment && (
  <Alert severity="success" icon={<CheckCircle />} sx={{ mb: 2, py: 0 }}>
    <Typography variant="caption">Payment recorded via {payments.find(p => p.order_id === order.id)?.payment_method}</Typography>
  </Alert>
)}


                          

                            {isUnpaidCompleted && (
                              <Alert severity="error" icon={<WarningAmber />} sx={{ mb: 2, py: 0 }}>
                                <Typography variant="caption">⚠️ Completed but NO payment recorded! Please print receipt.</Typography>
                              </Alert>
                            )}

                            {isActiveOrder && !hasPayment && (
                              <Alert severity="warning" icon={<WarningAmber />} sx={{ mb: 2, py: 0 }}>
                                <Typography variant="caption">⚠️ Active order - waiting for completion and payment</Typography>
                              </Alert>
                            )}

                            <Divider sx={{ my: 1.5 }} />

                            <Box sx={{ mb: 2 }}>
                              <Typography variant="body2" color="textSecondary" gutterBottom>
                                Items ({order.items?.length || 0})
                              </Typography>
                              {order.items && order.items.slice(0, 3).map((item, idx) => (
                                <Box key={idx} sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                  <Typography variant="body2" noWrap sx={{ maxWidth: '55%' }}>{item.item_name}</Typography>
                                  <Typography variant="body2">x{item.quantity}</Typography>
                                  <Typography variant="body2">₦{(item.quantity * item.unit_price).toFixed(2)}</Typography>
                                </Box>
                              ))}
                              {order.items && order.items.length > 3 && (
                                <Typography variant="caption" color="textSecondary">+{order.items.length - 3} more items</Typography>
                              )}
                            </Box>

                            <Divider sx={{ my: 1.5 }} />

                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                              <Box>
                                <Typography variant="body2" color="textSecondary">Total Amount</Typography>
                                <Typography variant="h6" color={isCompleted ? 'success.main' : 'primary'} fontWeight="bold">
                                  {formatCurrency(order.final_amount)}
                                </Typography>
                              </Box>
                              {hasPayment && (
                                <Box textAlign="right">
                                  <Typography variant="caption" color="success.main">Paid</Typography>
                                  <Typography variant="body2" fontWeight="bold">{formatCurrency(paidAmount)}</Typography>
                                </Box>
                              )}
                            </Box>

                            <Box sx={{ display: 'flex', gap: 1 }}>
                              {isCompleted ? (
                                <Button 
                                  fullWidth 
                                  variant="contained" 
                                  startIcon={<Print />} 
                                  onClick={() => handleOpenPrintDialog(order)} 
                                  sx={{ 
                                    background: hasPayment 
                                      ? 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)'
                                      : 'linear-gradient(135deg, #2E7D32 0%, #1B5E20 100%)',
                                    '&:hover': { transform: 'scale(1.02)' }, 
                                    transition: 'transform 0.2s ease' 
                                  }}
                                >
                                  {hasPayment ? 'Reprint Receipt' : 'Print Receipt & Record Payment'}
                                </Button>
                              ) : (
                                <Button fullWidth variant="outlined" disabled sx={{ opacity: 0.6 }}>
                                  {order.status === 'cancelled' ? 'Order Cancelled' : 'Awaiting Completion'}
                                </Button>
                              )}
                              <Tooltip title="View Details">
                                <IconButton color="info" onClick={() => { setSelectedOrder(order); setOpenOrderDetailsDialog(true); }}>
                                  <Visibility />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </CardContent>
                        </OrderCard>
                      </Grow>
                    </Grid>
                  );
                })
              )}
            </Grid>

            {totalPages > 1 && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                <Pagination count={totalPages} page={page + 1} onChange={(event, newPage) => setPage(newPage - 1)} color="primary" size={isMobile ? 'small' : 'large'} showFirstButton showLastButton />
              </Box>
            )}
          </>
        )}
      </Box>
    );
  };

  // Render Payments Tab
  const renderPaymentsTab = () => {
    const totalPaidAmount = payments
      .filter(p => p.payment_method !== 'Complimentary')
      .reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0);
    
    const complimentaryTotal = payments
      .filter(p => p.payment_method === 'Complimentary')
      .reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0);
    
    const complimentaryCount = payments.filter(p => p.payment_method === 'Complimentary').length;

    return (
      <Box>
        <Typography variant="h4" gutterBottom sx={{ background: 'linear-gradient(135deg, #1a024b 0%, #140522 100%)', backgroundClip: 'text', WebkitBackgroundClip: 'text', color: 'transparent', mb: 3, fontWeight: 700 }}>
          💳 Payment History
        </Typography>

        <Grid container spacing={2} sx={{ mb: 4 }}>
          <Grid item xs={6} sm={4} md={2.4}>
            <StatCard><CardContent sx={{ textAlign: 'center', py: 2 }}><AttachMoney sx={{ fontSize: 32, color: '#4CAF50' }} /><Typography variant="h6" fontWeight="bold">{formatCurrency(paymentsSummary?.total_revenue || totalPaidAmount)}</Typography><Typography variant="caption">Total Revenue</Typography><Typography variant="caption" display="block" fontSize="10px">(Excludes Complimentary)</Typography></CardContent></StatCard>
          </Grid>
          <Grid item xs={6} sm={4} md={2.4}>
            <StatCard><CardContent sx={{ textAlign: 'center', py: 2 }}><Receipt sx={{ fontSize: 32, color: '#1976D2' }} /><Typography variant="h6" fontWeight="bold">{paymentsSummary?.total_payments || payments.length}</Typography><Typography variant="caption">Total Payments</Typography></CardContent></StatCard>
          </Grid>
          <Grid item xs={6} sm={4} md={2.4}>
            <StatCard><CardContent sx={{ textAlign: 'center', py: 2 }}><Money sx={{ fontSize: 32, color: '#4CAF50' }} /><Typography variant="h6" fontWeight="bold">{formatCurrency(paymentsSummary?.cash_total || 0)}</Typography><Typography variant="caption">Cash</Typography></CardContent></StatCard>
          </Grid>
          <Grid item xs={6} sm={4} md={2.4}>
            <StatCard><CardContent sx={{ textAlign: 'center', py: 2 }}><CreditCard sx={{ fontSize: 32, color: '#2196F3' }} /><Typography variant="h6" fontWeight="bold">{formatCurrency(paymentsSummary?.pos_total || 0)}</Typography><Typography variant="caption">POS Terminal</Typography></CardContent></StatCard>
          </Grid>
          <Grid item xs={6} sm={4} md={2.4}>
            <StatCard><CardContent sx={{ textAlign: 'center', py: 2 }}><AccountBalance sx={{ fontSize: 32, color: '#9C27B0' }} /><Typography variant="h6" fontWeight="bold">{formatCurrency(paymentsSummary?.transfer_total || 0)}</Typography><Typography variant="caption">Bank Transfer</Typography></CardContent></StatCard>
          </Grid>
          <Grid item xs={6} sm={4} md={2.4}>
            <StatCard><CardContent sx={{ textAlign: 'center', py: 2, bgcolor: '#FFF3E0' }}><CardGiftcard sx={{ fontSize: 32, color: '#FF9800' }} /><Typography variant="h6" fontWeight="bold" color="#FF9800">{paymentsSummary?.complimentary_count || complimentaryCount}</Typography><Typography variant="caption">Complimentary</Typography><Typography variant="caption" display="block" fontSize="10px">(Excluded from Revenue)</Typography></CardContent></StatCard>
          </Grid>
        </Grid>

        <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
          <FormControl size="small" sx={{ minWidth: 150 }}>
            <InputLabel>Date Filter</InputLabel>
            <Select value={paymentsDateFilter} onChange={(e) => setPaymentsDateFilter(e.target.value)} label="Date Filter">
              <MenuItem value="today">Today</MenuItem>
              <MenuItem value="week">Last 7 Days</MenuItem>
              <MenuItem value="month">Last 30 Days</MenuItem>
              <MenuItem value="all">All Time</MenuItem>
            </Select>
          </FormControl>
          <Button variant="outlined" startIcon={<Refresh />} onClick={loadPayments} disabled={paymentsLoading}>Refresh</Button>
        </Paper>

        {paymentsLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress size={50} /></Box>
        ) : (
          <TableContainer component={MuiPaper} sx={{ borderRadius: 3, overflow: 'hidden' }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                  <TableCell><strong>Payment #</strong></TableCell>
                  <TableCell><strong>Order #</strong></TableCell>
                  <TableCell><strong>Date</strong></TableCell>
                  <TableCell><strong>Guest Name</strong></TableCell>
                  <TableCell><strong>Order Type</strong></TableCell>
                  <TableCell><strong>Payment Method</strong></TableCell>
                  <TableCell align="right"><strong>Amount</strong></TableCell>
                  <TableCell><strong>Processed By</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedPayments.length === 0 ? (
                  <TableRow><TableCell colSpan={8} align="center"><Typography sx={{ py: 5 }}>No payment records found</Typography></TableCell></TableRow>
                ) : (
                  paginatedPayments.map((payment) => {
                    const isComplimentary = payment.payment_method === 'Complimentary';
                    return (
                      <TableRow 
                        key={payment.id} 
                        hover 
                        sx={{ 
                          backgroundColor: isComplimentary ? '#FFF8E1' : 'inherit',
                          '&:hover': { backgroundColor: isComplimentary ? '#FFECB3' : '#f5f5f5' }
                        }}
                      >
                        <TableCell><Typography variant="body2" fontWeight="medium" fontFamily="monospace">{payment.payment_number}</Typography></TableCell>
                        <TableCell><Typography variant="body2" fontWeight="medium">{payment.order_number}</Typography></TableCell>
                        <TableCell>{formatDate(payment.payment_date)}</TableCell>
                        <TableCell>{payment.guest_name || 'Walk-in Customer'}</TableCell>
                        <TableCell><Chip label={payment.order_type?.replace('_', ' ')} size="small" variant="outlined" /></TableCell>
                        <TableCell>
                          <Chip 
                            label={payment.payment_method} 
                            size="small" 
                            icon={payment.payment_method === 'Complimentary' ? <CardGiftcard /> : payment.payment_method === 'Cash' ? <Money /> : payment.payment_method === 'POS Terminal' ? <CreditCard /> : <AccountBalance />}
                            sx={{ 
                              bgcolor: isComplimentary ? '#FF9800' : (payment.payment_method === 'Cash' ? '#E8F5E9' : '#E3F2FD'),
                              color: isComplimentary ? 'white' : 'inherit',
                              fontWeight: 'medium',
                              '& .MuiChip-icon': { color: isComplimentary ? 'white' : 'inherit' }
                            }} 
                          />
                        </TableCell>
                        <TableCell align="right">
                          <Typography 
                            fontWeight="bold" 
                            color={isComplimentary ? '#FF9800' : 'success.main'}
                          >
                            {isComplimentary ? '₦0.00' : formatCurrency(payment.amount)}
                          </Typography>
                          {isComplimentary && (
                            <Typography variant="caption" display="block" color="textSecondary">No Payment</Typography>
                          )}
                        </TableCell>
                        <TableCell>{payment.created_by_name || payment.created_by || '-'}</TableCell>
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
              <TableFooter>
                <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                  <TableCell colSpan={5}><strong>Summary</strong></TableCell>
                  <TableCell><strong>Total Paid:</strong></TableCell>
                  <TableCell align="right"><strong>{formatCurrency(totalPaidAmount)}</strong></TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={5}></TableCell>
                  <TableCell>Complimentary Total:</TableCell>
                  <TableCell align="right">{formatCurrency(complimentaryTotal)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={8}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
                      <Typography variant="body2" color="textSecondary">
                        Total Records: {payments.length} | Total Paid (Excl. Complimentary): {formatCurrency(totalPaidAmount)}
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        )}
        
        {totalPaymentsPages > 1 && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            <Pagination count={totalPaymentsPages} page={paymentsPage + 1} onChange={(event, newPage) => setPaymentsPage(newPage - 1)} color="primary" />
          </Box>
        )}
      </Box>
    );
  };

  // Render Analytics Tab
  const renderAnalyticsTab = () => {
    const getDateString = (dateTimeStr) => {
      if (!dateTimeStr) return '';
      return dateTimeStr.split(' ')[0].split('T')[0];
    };
    
    const today = new Date().toISOString().split('T')[0];
    
    const totalRevenue = payments
      .filter(p => p.payment_method !== 'Complimentary')
      .reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0);
    
    const todayRevenue = payments
      .filter(p => {
        const paymentDate = getDateString(p.payment_date);
        return p.payment_method !== 'Complimentary' && paymentDate === today;
      })
      .reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0);
    
    const weekAgo = new Date();
    weekAgo.setDate(weekAgo.getDate() - 7);
    const weekRevenue = payments
      .filter(p => {
        if (p.payment_method === 'Complimentary') return false;
        const paymentDate = new Date(p.payment_date);
        return paymentDate >= weekAgo;
      })
      .reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0);
    
    const monthAgo = new Date();
    monthAgo.setDate(monthAgo.getDate() - 30);
    const monthRevenue = payments
      .filter(p => {
        if (p.payment_method === 'Complimentary') return false;
        const paymentDate = new Date(p.payment_date);
        return paymentDate >= monthAgo;
      })
      .reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0);

    const typeDistribution = ORDER_TYPES.map(type => {
      const typeOrderIds = payments
        .filter(p => {
          const order = allOrders.find(o => o.id === p.order_id);
          return order?.order_type === type.value && p.payment_method !== 'Complimentary';
        })
        .map(p => p.order_id);
      
      const uniqueOrderIds = [...new Set(typeOrderIds)];
      const revenue = payments
        .filter(p => typeOrderIds.includes(p.order_id) && p.payment_method !== 'Complimentary')
        .reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0);
      
      return { 
        ...type, 
        count: uniqueOrderIds.length, 
        revenue, 
        percentage: totalRevenue > 0 ? (revenue / totalRevenue) * 100 : 0 
      };
    });

    const paidOrderIds = new Set(
      payments
        .filter(p => p.payment_method !== 'Complimentary')
        .map(p => p.order_id)
    );
    
    const itemSales = {};
    allOrders.forEach(order => {
      if (!paidOrderIds.has(order.id)) return;
      if (order.status === 'cancelled') return;
      
      order.items?.forEach(item => {
        if (!itemSales[item.item_name]) {
          itemSales[item.item_name] = { quantity: 0, revenue: 0 };
        }
        itemSales[item.item_name].quantity += item.quantity;
        itemSales[item.item_name].revenue += item.quantity * item.unit_price;
      });
    });
    
    const popularItems = Object.entries(itemSales)
      .map(([name, data]) => ({ name, ...data }))
      .sort((a, b) => b.quantity - a.quantity)
      .slice(0, 10);

    const last7Days = [];
    for (let i = 6; i >= 0; i--) {
      const date = new Date();
      date.setDate(date.getDate() - i);
      const dateStr = date.toISOString().split('T')[0];
      
      const dayRevenue = payments
        .filter(p => {
          if (p.payment_method === 'Complimentary') return false;
          const paymentDate = getDateString(p.payment_date);
          return paymentDate === dateStr;
        })
        .reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0);
      
      const dayOrderIds = payments
        .filter(p => {
          if (p.payment_method === 'Complimentary') return false;
          const paymentDate = getDateString(p.payment_date);
          return paymentDate === dateStr;
        })
        .map(p => p.order_id);
      const uniqueOrderIds = [...new Set(dayOrderIds)];
      
      last7Days.push({ 
        date: date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }), 
        fullDate: date, 
        revenue: dayRevenue, 
        count: uniqueOrderIds.length 
      });
    }
    
    const maxRevenue = Math.max(...last7Days.map(d => d.revenue), 1);

    const paymentMethodStats = {
      Cash: payments.filter(p => p.payment_method === 'Cash').reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0),
      POS: payments.filter(p => p.payment_method === 'POS Terminal').reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0),
      Transfer: payments.filter(p => p.payment_method === 'Bank Transfer').reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0),
      QR: payments.filter(p => p.payment_method === 'QR Code').reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0),
      Complimentary: payments.filter(p => p.payment_method === 'Complimentary').length,
    };

    const totalPaidOrdersCount = new Set(
      payments.filter(p => p.payment_method !== 'Complimentary').map(p => p.order_id)
    ).size;

    const complimentaryCount = payments.filter(p => p.payment_method === 'Complimentary').length;
    const complimentaryTotal = payments
      .filter(p => p.payment_method === 'Complimentary')
      .reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0);

    return (
      <Box>
        <Typography variant="h4" gutterBottom sx={{ background: 'linear-gradient(135deg, #1a024b 0%, #140522 100%)', backgroundClip: 'text', WebkitBackgroundClip: 'text', color: 'transparent', mb: 3, fontWeight: 700 }}>
          📊 Revenue Analytics (Based on Actual Payments)
        </Typography>

        <Alert severity="info" sx={{ mb: 3 }}>
          <Typography variant="body2">
            <strong>Note:</strong> All revenue figures are calculated from <strong>ACTUAL PAYMENTS RECEIVED</strong> (excludes complimentary orders).
            Complimentary orders are shown separately for reference.
          </Typography>
        </Alert>

        <Grid container spacing={2} sx={{ mb: 4 }}>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard>
              <CardContent>
                <Box textAlign="center">
                  <AttachMoney sx={{ fontSize: 40, color: '#4CAF50' }} />
                  <Typography variant="h5" fontWeight="bold">{formatCurrency(totalRevenue)}</Typography>
                  <Typography variant="body2" color="textSecondary">Total Revenue</Typography>
                  <Typography variant="caption">From {totalPaidOrdersCount} paid orders</Typography>
                </Box>
              </CardContent>
            </StatCard>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard>
              <CardContent>
                <Box textAlign="center">
                  <CalendarToday sx={{ fontSize: 40, color: '#1976D2' }} />
                  <Typography variant="h5" fontWeight="bold">{formatCurrency(todayRevenue)}</Typography>
                  <Typography variant="body2" color="textSecondary">Today's Revenue</Typography>
                  <Typography variant="caption">{new Date().toLocaleDateString()}</Typography>
                </Box>
              </CardContent>
            </StatCard>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard>
              <CardContent>
                <Box textAlign="center">
                  <TrendingUp sx={{ fontSize: 40, color: '#FF9800' }} />
                  <Typography variant="h5" fontWeight="bold">{formatCurrency(weekRevenue)}</Typography>
                  <Typography variant="body2" color="textSecondary">Weekly Revenue</Typography>
                  <Typography variant="caption">Last 7 days</Typography>
                </Box>
              </CardContent>
            </StatCard>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard>
              <CardContent>
                <Box textAlign="center">
                  <ShowChart sx={{ fontSize: 40, color: '#9C27B0' }} />
                  <Typography variant="h5" fontWeight="bold">{formatCurrency(monthRevenue)}</Typography>
                  <Typography variant="body2" color="textSecondary">Monthly Revenue</Typography>
                  <Typography variant="caption">Last 30 days</Typography>
                </Box>
              </CardContent>
            </StatCard>
          </Grid>
        </Grid>

        {(complimentaryCount > 0 || complimentaryTotal > 0) && (
          <Alert severity="warning" icon={<CardGiftcard />} sx={{ mb: 3 }}>
            <Typography variant="body2">
              <strong>Complimentary Summary:</strong> {complimentaryCount} complimentary order(s) with total value of {formatCurrency(complimentaryTotal)} (excluded from revenue)
            </Typography>
          </Alert>
        )}

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <StatCard>
              <CardContent>
                <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <BarChart /> Daily Revenue (Last 7 Days) - Based on Payments
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1.5, height: 250, mt: 3, overflowX: 'auto', pb: 2 }}>
                  {last7Days.map((day, idx) => (
                    <Box key={idx} sx={{ flex: 1, minWidth: 80, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <Tooltip title={`₦${day.revenue.toLocaleString()} from ${day.count} paid orders`}>
                        <Box sx={{ 
                          width: '100%', 
                          maxWidth: 80, 
                          backgroundColor: day.revenue > 0 ? '#4CAF50' : '#E0E0E0',
                          height: `${(day.revenue / maxRevenue) * 200}px`, 
                          minHeight: day.revenue > 0 ? '8px' : '0', 
                          borderRadius: '8px 8px 0 0', 
                          transition: 'all 0.3s ease', 
                          cursor: 'pointer', 
                          '&:hover': { backgroundColor: '#388E3C', transform: 'scaleX(1.02)' } 
                        }} />
                      </Tooltip>
                      <Typography variant="caption" sx={{ mt: 1, fontWeight: 'medium' }}>{day.date}</Typography>
                      <Typography variant="caption" fontWeight="bold" color="success.main">{formatCurrency(day.revenue)}</Typography>
                      <Typography variant="caption" color="textSecondary">({day.count} orders)</Typography>
                    </Box>
                  ))}
                </Box>
              </CardContent>
            </StatCard>
          </Grid>

          <Grid item xs={12} md={6}>
            <StatCard>
              <CardContent>
                <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <PieChart /> Revenue by Outlet (Based on Payments)
                </Typography>
                <List>
                  {typeDistribution.map((type) => (
                    <ListItem key={type.value} divider>
                      <ListItemIcon>
                        <Avatar sx={{ bgcolor: type.color, width: 36, height: 36 }}>{type.icon}</Avatar>
                      </ListItemIcon>
                      <ListItemText 
                        primary={type.label} 
                        secondary={`${type.count} paid orders • ${type.percentage.toFixed(1)}% of revenue`} 
                      />
                      <Typography variant="body1" fontWeight="bold" sx={{ color: type.color }}>
                        {formatCurrency(type.revenue)}
                      </Typography>
                    </ListItem>
                  ))}
                </List>
              </CardContent>
            </StatCard>
          </Grid>

          <Grid item xs={12} md={6}>
            <StatCard>
              <CardContent>
                <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Fastfood /> Most Popular Items (From Paid Orders)
                </Typography>
                {popularItems.length === 0 ? (
                  <Typography variant="body2" color="textSecondary" sx={{ textAlign: 'center', py: 5 }}>
                    No sales data available from paid orders
                  </Typography>
                ) : (
                  <List>
                    {popularItems.map((item, index) => (
                      <ListItem key={index} divider={index < popularItems.length - 1}>
                        <ListItemIcon>
                          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#17064d', minWidth: 35 }}>#{index + 1}</Typography>
                        </ListItemIcon>
                        <ListItemText 
                          primary={item.name} 
                          secondary={`${item.quantity} sold • ${formatCurrency(item.revenue)}`} 
                        />
                        <Box sx={{ textAlign: 'right' }}>
                          <Typography variant="body2" fontWeight="bold">{item.quantity} units</Typography>
                          <LinearProgress 
                            variant="determinate" 
                            value={(item.quantity / popularItems[0].quantity) * 100} 
                            sx={{ width: 80, borderRadius: 2, mt: 0.5 }} 
                          />
                        </Box>
                      </ListItem>
                    ))}
                  </List>
                )}
              </CardContent>
            </StatCard>
          </Grid>

          <Grid item xs={12}>
            <StatCard>
              <CardContent>
                <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <PaymentIcon /> Payment Method Distribution (Actual Payments)
                </Typography>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  <Grid item xs={6} sm={4} md={2.4}>
                    <Box sx={{ textAlign: 'center', p: 2, bgcolor: '#E8F5E9', borderRadius: 2 }}>
                      <Money sx={{ fontSize: 30, color: '#4CAF50' }} />
                      <Typography variant="h6">{formatCurrency(paymentMethodStats.Cash)}</Typography>
                      <Typography variant="caption">Cash</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2.4}>
                    <Box sx={{ textAlign: 'center', p: 2, bgcolor: '#E3F2FD', borderRadius: 2 }}>
                      <CreditCard sx={{ fontSize: 30, color: '#2196F3' }} />
                      <Typography variant="h6">{formatCurrency(paymentMethodStats.POS)}</Typography>
                      <Typography variant="caption">POS Terminal</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2.4}>
                    <Box sx={{ textAlign: 'center', p: 2, bgcolor: '#F3E5F5', borderRadius: 2 }}>
                      <AccountBalance sx={{ fontSize: 30, color: '#9C27B0' }} />
                      <Typography variant="h6">{formatCurrency(paymentMethodStats.Transfer)}</Typography>
                      <Typography variant="caption">Bank Transfer</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2.4}>
                    <Box sx={{ textAlign: 'center', p: 2, bgcolor: '#ECEFF1', borderRadius: 2 }}>
                      <QrCodeScanner sx={{ fontSize: 30, color: '#607D8B' }} />
                      <Typography variant="h6">{formatCurrency(paymentMethodStats.QR)}</Typography>
                      <Typography variant="caption">QR Code</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6} sm={4} md={2.4}>
                    <Box sx={{ textAlign: 'center', p: 2, bgcolor: '#FFF3E0', borderRadius: 2 }}>
                      <CardGiftcard sx={{ fontSize: 30, color: '#FF9800' }} />
                      <Typography variant="h6">{paymentMethodStats.Complimentary}</Typography>
                      <Typography variant="caption">Complimentary Orders</Typography>
                      <Typography variant="caption" display="block" fontSize="10px">(Excluded from Revenue)</Typography>
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </StatCard>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const tabLabels = [
    { label: 'Orders', icon: <Receipt /> },
    { label: 'Payments', icon: <PaymentIcon /> },
    { label: 'Analytics', icon: <TrendingUp /> },
  ];

  const handleTabChange = (event, newValue) => { setActiveTab(newValue); };

  const renderTabContent = () => {
    switch (activeTab) {
      case 0: return renderOrdersTab();
      case 1: return renderPaymentsTab();
      case 2: return renderAnalyticsTab();
      default: return renderOrdersTab();
    }
  };

  // Close Day Confirmation Dialog
  const renderCloseDayDialog = () => (
    <Dialog open={openCloseDayDialog} onClose={() => setOpenCloseDayDialog(false)} maxWidth="md" fullWidth>
      <DialogTitle sx={{ background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)', color: 'white' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <LockClock /> 
          <Typography variant="h6">Close Day - End of Day Operations</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 2 }}>
          <Alert severity="warning" icon={<WarningAmber />}>
            <Typography variant="body2" fontWeight="bold" gutterBottom>
              Before closing the day, please ensure:
            </Typography>
            <ul style={{ margin: '8px 0 0 20px' }}>
              <li>✅ All orders are either COMPLETED or CANCELLED</li>
              <li>✅ All completed orders have receipts printed</li>
              <li>✅ All payments are recorded in the system</li>
              <li>✅ No active orders in Pending, Confirmed, Preparing, Ready, or Served status</li>
            </ul>
          </Alert>

          <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="subtitle2" gutterBottom color="primary">
              Current Status Check
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="body2" color="textSecondary">Pending Orders:</Typography>
                <Typography variant="body2" fontWeight="bold" color={pendingOrdersCount > 0 ? 'error' : 'success'}>
                  {pendingOrdersCount} {pendingOrdersCount > 0 ? '(Must be completed/cancelled)' : '(Ready)'}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" color="textSecondary">Unpaid Completed Orders:</Typography>
                <Typography variant="body2" fontWeight="bold" color={unpaidOrdersCount > 0 ? 'error' : 'success'}>
                  {unpaidOrdersCount} {unpaidOrdersCount > 0 ? '(Must print receipts)' : '(Ready)'}
                </Typography>
              </Grid>
            </Grid>
          </Paper>

          <TextField
            fullWidth
            label="Closure Reason (Optional)"
            multiline
            rows={2}
            value={closureReason}
            onChange={(e) => setClosureReason(e.target.value)}
            placeholder="E.g., End of day, Shift change, etc."
          />

          {canCloseDay() ? (
            <TextField
              fullWidth
              label="Type 'CLOSE DAY' to confirm"
              value={closeConfirmText}
              onChange={(e) => setCloseConfirmText(e.target.value)}
              helperText="This confirmation prevents accidental day closure"
              error={closeConfirmText !== '' && closeConfirmText !== 'CLOSE DAY'}
            />
          ) : (
            <Alert severity="error" icon={<WarningAmber />}>
              <Typography variant="body2">
                <strong>Cannot close day until:</strong>
                {pendingOrdersCount > 0 && <li>{pendingOrdersCount} active order(s) are completed or cancelled</li>}
                {unpaidOrdersCount > 0 && <li>{unpaidOrdersCount} completed order(s) have receipts printed and payments recorded</li>}
              </Typography>
            </Alert>
          )}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button onClick={() => setOpenCloseDayDialog(false)}>Cancel</Button>
        <CloseDayButton 
          onClick={handleCloseDay} 
          disabled={!canCloseDay() || closeConfirmText !== 'CLOSE DAY' || closingDay}
          canclose={canCloseDay()}
          startIcon={closingDay ? <CircularProgress size={20} /> : <LockClock />}
        >
          {closingDay ? 'Closing...' : 'Confirm Close Day'}
        </CloseDayButton>
      </DialogActions>
    </Dialog>
  );

  // Day Closure Summary Dialog
  const renderClosureSummaryDialog = () => (
    <Dialog open={openClosureDialog} onClose={() => setOpenClosureDialog(false)} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ background: 'linear-gradient(135deg, #4caf50 0%, #2e7d32 100%)', color: 'white' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Summarize /> 
          <Typography variant="h6">Day Closure Summary</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        {dayClosureSummary && (
          <Stack spacing={2} sx={{ mt: 2 }}>
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Typography variant="subtitle2" gutterBottom color="primary">
                Closure Information
              </Typography>
              <Grid container spacing={1}>
                <Grid item xs={6}><Typography variant="caption" color="textSecondary">Date:</Typography></Grid>
                <Grid item xs={6}><Typography variant="body2">{dayClosureSummary.date}</Typography></Grid>
                <Grid item xs={6}><Typography variant="caption" color="textSecondary">Closed By:</Typography></Grid>
                <Grid item xs={6}><Typography variant="body2">{dayClosureSummary.closed_by}</Typography></Grid>
                <Grid item xs={6}><Typography variant="caption" color="textSecondary">Total Orders:</Typography></Grid>
                <Grid item xs={6}><Typography variant="body2" fontWeight="bold">{dayClosureSummary.total_orders}</Typography></Grid>
              </Grid>
            </Paper>

            <Paper variant="outlined" sx={{ p: 2 }}>
              <Typography variant="subtitle2" gutterBottom color="primary">
                Financial Summary
              </Typography>
              <Grid container spacing={1}>
                <Grid item xs={6}><Typography variant="caption" color="textSecondary">Total Revenue:</Typography></Grid>
                <Grid item xs={6}><Typography variant="body2" fontWeight="bold" color="success.main">{formatCurrency(dayClosureSummary.total_revenue)}</Typography></Grid>
                <Grid item xs={6}><Typography variant="caption" color="textSecondary">Cash Payments:</Typography></Grid>
                <Grid item xs={6}><Typography variant="body2">{formatCurrency(dayClosureSummary.total_cash)}</Typography></Grid>
                <Grid item xs={6}><Typography variant="caption" color="textSecondary">POS Payments:</Typography></Grid>
                <Grid item xs={6}><Typography variant="body2">{formatCurrency(dayClosureSummary.total_pos)}</Typography></Grid>
                <Grid item xs={6}><Typography variant="caption" color="textSecondary">Bank Transfers:</Typography></Grid>
                <Grid item xs={6}><Typography variant="body2">{formatCurrency(dayClosureSummary.total_transfer)}</Typography></Grid>
                <Grid item xs={6}><Typography variant="caption" color="textSecondary">Complimentary Orders:</Typography></Grid>
                <Grid item xs={6}><Typography variant="body2">{dayClosureSummary.complimentary_count}</Typography></Grid>
              </Grid>
            </Paper>
            
            <Button
              fullWidth
              variant="contained"
              color="primary"
              startIcon={startingNewDay ? <CircularProgress size={20} /> : <Today />}
              onClick={handleStartNewDay}
              disabled={startingNewDay}
              sx={{ mt: 2 }}
            >
              {startingNewDay ? 'Starting New Day...' : 'Start New Day'}
            </Button>
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenClosureDialog(false)}>Close</Button>
        <Button variant="contained" startIcon={<Print />} onClick={() => window.print()}>Print Summary</Button>
      </DialogActions>
    </Dialog>
  );

  // Pending Start New Day Dialog (Unpaid Orders)
  const renderPendingStartNewDayDialog = () => (
    <Dialog open={pendingStartNewDayDialog} onClose={() => setPendingStartNewDayDialog(false)} maxWidth="md" fullWidth>
      <DialogTitle sx={{ background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)', color: 'white' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <WarningAmber /> 
          <Typography variant="h6">Cannot Start New Day - Unpaid Orders Found</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 2 }}>
          <Alert severity="error">
            <Typography variant="body2">
              <strong>⚠️ {unpaidOrdersCount} completed order(s) without payment recorded!</strong><br />
              Please process payments for these orders before starting a new day.
            </Typography>
          </Alert>

          {unpaidOrdersList.length > 0 && (
            <TableContainer component={MuiPaper}>
              <Table size="small">
                <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                  <TableRow>
                    <TableCell><strong>Order #</strong></TableCell>
                    <TableCell><strong>Date</strong></TableCell>
                    <TableCell><strong>Guest</strong></TableCell>
                    <TableCell><strong>Amount</strong></TableCell>
                    <TableCell align="center"><strong>Action</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {unpaidOrdersList.slice(0, 10).map((order) => (
                    <TableRow key={order.id}>
                      <TableCell>{order.order_number}</TableCell>
                      <TableCell>{getDateOnly(order.created_at)}</TableCell>
                      <TableCell>{order.guest_name}</TableCell>
                      <TableCell>{formatCurrency(order.final_amount)}</TableCell>
                      <TableCell align="center">
                        <Button 
                          size="small" 
                          variant="contained" 
                          color="primary"
                          startIcon={<Print />}
                          onClick={() => {
                            setPendingStartNewDayDialog(false);
                            handleOpenPrintDialog(order);
                          }}
                        >
                          Print Receipt
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}

        
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setPendingStartNewDayDialog(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  );

  return (
    <Box sx={{ display: 'flex', bgcolor: '#f5f7fa', minHeight: '100vh' }}>
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      
      <Box sx={{ flexGrow: 1, p: { xs: 2, sm: 3 }, ml: isMobile ? 0 : sidebarOpen ? 30 : 7, mt: 0, maxWidth: '1600px', mx: 'auto', transition: 'margin 0.3s ease' }}>
        <TopNav onLogout={() => navigate('/HotelAdmin')} onNotificationClick={() => alert('Notifications')} toggleSidebar={toggleSidebar} />
        
        <Paper elevation={0} sx={{ p: { xs: 3, sm: 4 }, mt: 3, background: 'linear-gradient(135deg, #0e1da3 0%, #320e65 100%)', color: 'white', borderRadius: 4, position: 'relative', overflow: 'hidden' }}>
          <Box sx={{ position: 'relative', zIndex: 1 }}>
            <Typography variant="h4" fontWeight="bold" gutterBottom>💰 Cashier Dashboard</Typography>
            <Typography variant="subtitle1">Process payments, print receipts, and manage transactions</Typography>
          </Box>
          <Box sx={{ position: 'absolute', right: -30, bottom: -30, opacity: 0.1, transform: 'rotate(-15deg)' }}><AttachMoney sx={{ fontSize: 200 }} /></Box>
        </Paper>
        
        <Paper elevation={2} sx={{ mt: 3, borderRadius: 4, overflow: 'hidden' }}>
          <Tabs value={activeTab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto" sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'background.paper', '& .MuiTab-root': { textTransform: 'none', fontWeight: 600, fontSize: '15px', py: 2 }, '& .Mui-selected': { color: '#120b41' }, '& .MuiTabs-indicator': { backgroundColor: '#0a0323', height: 3 } }}>
            {tabLabels.map((tab, index) => (
              <Tab key={index} label={<Badge badgeContent={index === 0 ? allOrders.filter(o => o.status === 'completed').length : index === 1 ? payments.length : 0} color={index === 0 ? 'success' : 'primary'}>{tab.label}</Badge>} icon={tab.icon} iconPosition="start" />
            ))}
          </Tabs>
          
          <Box sx={{ p: { xs: 2, sm: 3 } }}>{renderTabContent()}</Box>
        </Paper>
      </Box>

      {/* Print Receipt Dialog */}
      <Dialog open={openPrintDialog} onClose={handleClosePrintDialog} maxWidth="sm" fullWidth TransitionComponent={Grow}>
        <DialogTitle sx={{ background: 'linear-gradient(135deg, #0c0421 0%, #0a041f 100%)', color: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}><Print /><Typography variant="h5">{reprintMode ? 'Reprint Receipt' : 'Print Receipt'}</Typography></Box>
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          {selectedOrder && (
            <>
              <Alert severity={reprintMode ? "warning" : "info"} sx={{ mb: 3 }}>
                <Typography variant="body2">
                  <strong>Order #{selectedOrder.order_number}</strong><br />
                  Total Amount: <strong>{formatCurrency(selectedOrder.final_amount)}</strong>
                  {reprintMode && <><br /><strong>Previously paid via: {existingPaymentMethod}</strong><br />This is a reprint - no new payment will be recorded.</>}
                  {!reprintMode && <><br />Payment will be recorded with today's date: <strong>{new Date().toLocaleDateString()}</strong></>}
                </Typography>
              </Alert>

              {!reprintMode && (
                <>
                  <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>Select Payment Method</Typography>
                  <Grid container spacing={2}>
                    {PAYMENT_METHODS.map((method) => (
                      <Grid item xs={12} sm={6} key={method.value}>
                        <PaymentMethodCard selected={selectedPaymentMethod === method.value} onClick={() => setSelectedPaymentMethod(method.value)}>
                          <CardContent sx={{ py: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Avatar sx={{ bgcolor: method.color, width: 45, height: 45 }}>{method.icon}</Avatar>
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="subtitle1" fontWeight="bold">{method.label}</Typography>
                              <Typography variant="caption" color="textSecondary">{method.description}</Typography>
                              {method.isFree && <Chip label="No Payment" size="small" color="warning" sx={{ mt: 0.5 }} />}
                            </Box>
                            {selectedPaymentMethod === method.value && <CheckCircle sx={{ color: method.color }} />}
                          </CardContent>
                        </PaymentMethodCard>
                      </Grid>
                    ))}
                  </Grid>

                  {selectedPaymentMethod === 'Complimentary' && (
                    <Alert severity="warning" sx={{ mt: 3 }}>
                      <Typography variant="body2"><strong>Complimentary Order</strong> - No payment will be recorded. The receipt will clearly indicate "NO PAYMENT".</Typography>
                    </Alert>
                  )}
                </>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button onClick={handleClosePrintDialog} variant="outlined">Cancel</Button>
          <Button onClick={handlePrintReceipt} variant="contained" disabled={(!reprintMode && !selectedPaymentMethod) || printing} startIcon={printing ? <CircularProgress size={20} /> : <Print />} sx={{ background: 'linear-gradient(135deg, #2E7D32 0%, #1B5E20 100%)', '&:hover': { transform: 'scale(1.02)' }, transition: 'transform 0.2s ease' }}>
            {printing ? 'Processing...' : (reprintMode ? 'Reprint Receipt' : 'Print Receipt & Record Payment')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Order Details Dialog */}
      <Dialog open={openOrderDetailsDialog} onClose={() => setOpenOrderDetailsDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ bgcolor: '#09083b', color: 'white' }}>Order #{selectedOrder?.order_number} Details</DialogTitle>
        <DialogContent>
          {selectedOrder && (
            <Box sx={{ mt: 2 }}>
              <TableContainer component={MuiPaper} variant="outlined" sx={{ borderRadius: 2 }}>
                <Table size="small">
                  <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                    <TableRow><TableCell><strong>Item</strong></TableCell><TableCell align="right"><strong>Quantity</strong></TableCell><TableCell align="right"><strong>Unit Price</strong></TableCell><TableCell align="right"><strong>Total</strong></TableCell></TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedOrder.items?.map((item, index) => (
                      <TableRow key={index}><TableCell>{item.item_name}</TableCell><TableCell align="right">{item.quantity}</TableCell><TableCell align="right">{formatCurrency(item.unit_price)}</TableCell><TableCell align="right">{formatCurrency(item.quantity * item.unit_price)}</TableCell></TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <Box sx={{ mt: 3, p: 2.5, bgcolor: '#f5f5f5', borderRadius: 2 }}>
                <Grid container spacing={1}>
                  <Grid item xs={6}><Typography variant="body2">Subtotal:</Typography></Grid><Grid item xs={6}><Typography variant="body2" align="right">{formatCurrency(selectedOrder.total_amount)}</Typography></Grid>
                  {TAX_RATE > 0 && (<><Grid item xs={6}><Typography variant="body2">Tax ({TAX_RATE}%):</Typography></Grid><Grid item xs={6}><Typography variant="body2" align="right">{formatCurrency(selectedOrder.tax_amount)}</Typography></Grid></>)}
                  {selectedOrder.order_type === 'room_service' && parseFloat(selectedOrder.service_charge || 0) > 0 && (<><Grid item xs={6}><Typography variant="body2">Service Charge ({SERVICE_CHARGE_RATE}%):</Typography></Grid><Grid item xs={6}><Typography variant="body2" align="right">{formatCurrency(selectedOrder.service_charge)}</Typography></Grid></>)}
                  <Grid item xs={12}><Divider sx={{ my: 1 }} /></Grid>
                  <Grid item xs={6}><Typography variant="h6">Total:</Typography></Grid><Grid item xs={6}><Typography variant="h6" align="right" color="primary">{formatCurrency(selectedOrder.final_amount)}</Typography></Grid>
                </Grid>
              </Box>

              {selectedOrder.special_instructions && (
                <Box sx={{ mt: 2, p: 2, bgcolor: '#FFF8E1', borderRadius: 2 }}>
                  <Typography variant="subtitle2" gutterBottom>📝 Special Instructions:</Typography>
                  <Typography variant="body2">{selectedOrder.special_instructions}</Typography>
                </Box>
              )}
              
              <Box sx={{ mt: 2, p: 2, bgcolor: '#E3F2FD', borderRadius: 2 }}>
                <Typography variant="subtitle2" gutterBottom>ℹ️ Order Information:</Typography>
                <Grid container spacing={1}>
                  <Grid item xs={6}><Typography variant="caption" color="textSecondary">Created By:</Typography><Typography variant="body2">{selectedOrder.created_by_name || 'Staff'}</Typography></Grid>
                  <Grid item xs={6}><Typography variant="caption" color="textSecondary">Created At:</Typography><Typography variant="body2">{formatDate(selectedOrder.created_at)}</Typography></Grid>
                  {selectedOrder.served_by_name && (<><Grid item xs={6}><Typography variant="caption" color="textSecondary">Served By:</Typography><Typography variant="body2">{selectedOrder.served_by_name}</Typography></Grid><Grid item xs={6}><Typography variant="caption" color="textSecondary">Served At:</Typography><Typography variant="body2">{formatDate(selectedOrder.served_at)}</Typography></Grid></>)}
                </Grid>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenOrderDetailsDialog(false)}>Close</Button>
          {selectedOrder && selectedOrder.status === 'completed' && (
            <Button variant="contained" startIcon={<Print />} onClick={() => { setOpenOrderDetailsDialog(false); handleOpenPrintDialog(selectedOrder); }} sx={{ bgcolor: '#2E7D32' }}>Print Receipt</Button>
          )}
        </DialogActions>
      </Dialog>

      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} TransitionComponent={Slide}>
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }}>{snackbar.message}</Alert>
      </Snackbar>

      {/* Day Closure Dialogs */}
      {renderCloseDayDialog()}
      {renderClosureSummaryDialog()}
      {renderPendingStartNewDayDialog()}

      <ClosePreviousShift
  open={openClosePreviousShift}
  onClose={() => setOpenClosePreviousShift(false)}
  onShiftClosed={() => {
    // Refresh data after shift is closed
    loadData();
    checkDayClosureStatus();
  }}
/>
    </Box>
  );
};

export default CashierFBMgmt;